import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  Renderer2
} from '@angular/core';
import {NotificationService} from '../../../../../core/notification/notification.service';
import {ProTasksManagerService} from '../pro-tasks-manager.service';
import {ActivatedRoute, Router} from '@angular/router';
import {lastValueFrom, Subject, Subscription} from 'rxjs';
import {
  LatestVehiclesInfoService
} from '../../../../../core/component/latest-vehicles-info/latest-vehicles-info.service';
import {LatestVehicleEntry} from '../../../../../core/component/latest-vehicles-info/model/latest-vehicle-entry';
import {ProTasksEditEntry} from './model/pro-tasks-edit.entry';
import {Alphabet} from '../../../../../core/model/alphabet';
import {
  AbstractControl,
  UntypedFormArray,
  UntypedFormBuilder,
  UntypedFormGroup,
  ValidatorFn,
  Validators
} from '@angular/forms';
import {PlacesEntry} from '../../../../../core/component/places/model/places.entry';
import {ProTaskForm} from './model/pro-task.form';
import {EnumValues} from 'enum-values';
import {TaskTypes} from '../../tasks-manager/task-form/task-types';
import {TranslateService} from '@ngx-translate/core';
import {InfoOptionEntry} from '../../tasks-manager/tasks-queue/model/info-option.entry';
import {AdditionalInfoForm} from '../../tasks-manager/task-form/additional-info-form';
import {PoiInsertTask, ProTasksFormStateService} from './pro-tasks-form-state.service';
import {PlaceSource} from '../../../../../core/component/places/model/place-source';
import {PlacesService, POST_CODE_REGEX} from '../../../../../core/component/places/places.service';
import {MathUtils} from '../../../../../core/commons/math-utils';
import {TaskUtils} from '../../tasks-manager/utils/task-utils';
import {moveItemInArray} from '@angular/cdk/drag-drop';
import {MapPosition} from '../../route/metamodel';
import {v4 as UUID} from 'uuid';
import {ProTasksFormRouteUtils} from './map/utils/pro-tasks-form-route-utils';
import {GlobalService} from '../../../../../core/global/global.service';
import {CookieService} from 'ngx-cookie';
import {Location} from '@angular/common';
import {
  calculateTasksFuelData,
  checkForFuelWarning,
  executing,
  VehicleFuelType
} from './properties/fuel-chart/fuel-calculation.utils';
import {AuthStorage} from '../../../../../core/auth/auth-storage';
import {ProTaskManagerUtilsComponent} from '../utils/pro-task-manager-utils.component';
import {CurrentTaskEntry} from './model/current-task.entry';
import {
  TASKS_ALTERNATIVES,
  TASKS_BAD_MARKED_ROADS,
  TASKS_CONDITIONAL_RESTRICTIONS,
  TASKS_EXCLUDED_COUNTRIES,
  TASKS_INCIDENTS,
  TASKS_TRAFFIC
} from '../../../../../core/global/cookies.constants';
import {debounceTime, first, pairwise, startWith, takeUntil} from 'rxjs/operators';
import {ArrayUtils} from '../../../../../core/commons/array-utils';
import {TruckConstants} from '../../truck-constants';
import {TemplateDetailsEntry} from './properties/templates/model/template.entry';
import {toFullForm} from './properties/templates/template.utils';
import {
  emailValidator,
  maxWeekDurationInMinutesValidator,
  requiredIfAnyFilled,
  temperatureRange,
  validateFieldTillLaterThanFrom,
  validInteger
} from '../../../../../core/validators';
import {environment} from '../../../../../../environments/environment';
import {PoiPlaceDetails} from '../../../../../core/component/places/model/poi-place-details';
import {SubscriptionUtils} from '../../../../../core/commons/subscription.utils';
import {LkwOrderEntry} from '../lkw-orders/model/lkw-order.entry';
import {LkwItem} from '../lkw-orders/model/lkw-item';
import {OlRouteService} from '../../../../../core/component/ol-route/ol-route.service';
import {ProTasksManagerStateService} from '../pro-tasks-manager-state.service';
import {FreezerModeType} from './model/freezer-mode.type';
import {round} from '@turf/turf';
import {BoschParkingFormComponent} from '../../../../../core/component/parking-form/bosch/bosch-parking-form.component';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {NewBookingInfo} from '../../../../../core/component/parking-form/bosch/model/bosch-booking.info';
import {TaskEtaRequest} from './model/task-eta-request';
import {appendReservationLink} from '../../../../../core/component/parking-form/parking.utils';
import {
  TravisParkingFormComponent
} from '../../../../../core/component/parking-form/travis/travis-parking-form.component';
import {TaskConfirmComponent} from '../modal/task-confirm/task-confirm.component';
import {UnveroSelectedStationEntry} from './model/unvero/unvero-selected-station.entry';
import {TollCountryEntry} from '../../tasks-manager/tasks-queue/model/tolls/toll-country.entry';
import {ClipboardService} from 'ngx-clipboard';
import {OptimalFuelling} from '../../../../../core/component/control-panel/model/optimal-fuelling';
import {PoiModalComponent} from '../../../../../core/component/poi-modal/poi-modal.component';
import {POIForm} from '../../../poi/poi/model/poi.form';
import {ProTasksRoutePrice} from './model/pro-tasks-route-price';
import {Permissions} from '../../../../../core/auth/permissions';
import {Module} from '../../../../../core/model/profile';
import {ServicePlanningTabState} from './properties/repair-orders/service-planning-tab-state';
import {DeviceService} from "../../../../../core/commons/device.service";
import {
  FuellingReplanningConfigsService
} from "../../../settings/global-config/fuelling-replanning-configs/fuelling-replanning-configs.service";
import {FuellingPlanResponse} from "./model/fuelling-plan-response";

export const FREEZER_TEMPERATURE_ID = -1;
export const ORDER_ADDITIONAL_ID = -2;
export const LOAD_TIME_ADDITIONAL_ID = -3;
export const FUEL_ADDITIONAL_ID = -5;
export const ADBLUE_ADDITIONAL_ID = -6;
export const CARGO_WEIGHT_ADDITIONAL_ID = -8;
export const FREEZER_MODE_ID = -9;
export const KIND_OF_GOODS_ADDITIONAL_ID = -13;
export const TEMPERATURE_LOW_ID = -16;
export const TEMPERATURE_HIGH_ID = -17;
export const SECOND_TEMPERATURE_LOW_ID = -18;
export const SECOND_TEMPERATURE_HIGH_ID = -19;
export const FREEZERS_IDS = [
  TEMPERATURE_LOW_ID,
  TEMPERATURE_HIGH_ID,
  SECOND_TEMPERATURE_LOW_ID,
  SECOND_TEMPERATURE_HIGH_ID];
export const FREEZER_SECOND_COMPARTMENT_TEMPERATURE_ID = -21;
const SECONDS_IN_MINUTE = 60;
export const FULL_TANK = '-1';
export const DEFAULT_TRUCK_FUEL_USAGE = 30.0;

@Component({
  selector: 'app-pro-tasks-form',
  templateUrl: './pro-tasks-form.component.html',
  styleUrls: ['./pro-tasks-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProTasksFormComponent implements OnInit, OnDestroy {

  @Output()
  public cancels = new EventEmitter<void>();

  @Output()
  public saves = new EventEmitter<void>();

  @Input()
  public reset: number;

  @Input()
  public suggestReplan: boolean;

  @Input()
  public replanSuggestionId: number;

  @Input()
  public executingDistance: number;

  @Input()
  public lkwOrder: LkwOrderEntry;

  @Input()
  public optimalFuelling: OptimalFuelling[];

  public vehicle: number;

  public data: ProTasksEditEntry;

  public latestVehicles: LatestVehicleEntry[] = [];

  public isMobile = false;

  private formsLoaded = false;
  public forms: UntypedFormGroup[] = [];
  public activeForm: UntypedFormGroup;
  public unsavedForms: UntypedFormGroup[] = [];
  public activeFormIdx = 0;
  private poiInsertTask: PoiInsertTask;
  public traveledDistance = 0;

  public mapActive = false;
  public taskFormActive = true;
  public tabsActive = false;

  public taskTypes: string[] = AuthStorage.getTasksTypesConfigs();
  public taskTypesDuration: Map<string, number> = new Map<string, number>();

  public searchSubject: Subject<any> = new Subject();
  public searchResult: any[] = [];

  public files: Map<string, any> = new Map<string, any>();
  private formsIdxWithDifferentOrigins: number[] = [];

  public alphabet = Alphabet.ARRAY;
  private additionalOptions: InfoOptionEntry[] = [];
  public additionalInfoConfigs: number[] = [];
  public zones: string[] = [];

  public routePlannerActive = false;
  public routeParamsActive = false;
  public fuellingActive = false;
  public parkingsActive = false;
  public templatesActive = false;
  public formsActive = false;
  public repairOrdersActive = false;
  public servicePlanningEnabled = Permissions.hasModule(Module.SERVICES) && AuthStorage.canPlanServices();
  public servicePlanningState = ServicePlanningTabState.NONE;
  public enabledAddresses: boolean;
  public useLastTripCoords = false;
  public forbiddenManageTasks = AuthStorage.isForbiddenManageTasks();
  public copyEnabled = AuthStorage.getTasksConfigs().enabledInfoCopy;
  public keepSameTemperature = AuthStorage.getTasksConfigs().keepSameTemperature;
  private enabledDefaultWaypoints = false;
  private enabledOriginalSearchText = false;

  protected aiSmartRouting = Permissions.hasModule(Module.AI_SMART_ROUTING);
  protected fuellingModule = Permissions.hasModule(Module.FUELLING);

  public keyword: string;
  public activeType: string;
  private selectedItem: any;
  private dropDownIndex: number;

  private oldTaskInfo: any;
  private notEditingOldTask: boolean;
  private oldTaskIdx: number;
  private oldTaskFormType: string;

  public planningRouteCost: ProTasksRoutePrice;
  public etas = new Map<string, string>();
  private serviceInsertSnapshot: ProTaskForm[];
  public currentRouteCost: ProTasksRoutePrice;
  public unsavedTasksRouteCost: ProTasksRoutePrice;
  public planningTotalDistance: number;
  public unsavedFormsTotalDistance: number;
  public eachTaskRouteCost: ProTasksRoutePrice[] = [];
  private averageFuelPrice: number;
  private averageTruckRentPrice: number;

  public totalCO2Emission = 0;
  public activeRouteCO2Emission = 0;
  public unsavedFormsCO2Emission = 0;
  public unsavedFormsDuration: number;
  public unsavedFormsTolls: number;
  public unsavedFormsCountryTolls: TollCountryEntry[] = [];

  private idSubs: Subscription;
  private vehicleSubs: Subscription;
  private searchSubs: Subscription;
  private routeChangesSubs: Subscription;
  private routeInfosSubs: Subscription;
  private taskSubs: Subscription;
  private oldTaskSubs: Subscription;
  private formValueChangeSubs: Subscription;
  private routeCostSubs: Subscription;
  private multiTemplateSubs: Subscription;
  private markedPaidRoadsTollsSubs: Subscription;
  private subSubject = new Subject<boolean>();
  private clickListener: () => void;
  private previousTasks: number[] = [];
  private lastKnownModification: string = null;

  public fuelUsageFor100km: number;
  public fuelType: VehicleFuelType | null;
  private readonly FUEL_WARNING_THRESHOLD = 0.2;
  public fuelWarning = false;
  private selectedUnveroStation: UnveroSelectedStationEntry;

  public saveInProgress: boolean;
  public routeReloading = false;
  public driverLang: string;
  public driverLangSub: Subscription;

  private suggestionsActive = false
  private tasksBeforeSuggestion: UntypedFormGroup[] = [];
  public isAutomaticReplanning = false;

  protected suggestionTaskUuids: string[] = [];

  constructor(private managerService: ProTasksManagerService,
              private notification: NotificationService,
              private route: ActivatedRoute,
              private latestVehiclesInfoService: LatestVehiclesInfoService,
              protected formBuilder: UntypedFormBuilder,
              private translate: TranslateService,
              private formStateService: ProTasksFormStateService,
              protected placesService: PlacesService,
              private renderer: Renderer2,
              private olRouteService: OlRouteService,
              private stateService: ProTasksManagerStateService,
              private cd: ChangeDetectorRef,
              private globalService: GlobalService,
              private cookieService: CookieService,
              private location: Location,
              private router: Router,
              private modalService: NgbModal,
              private clipboardService: ClipboardService,
              private deviceService: DeviceService,
              private fuellingReplanningConfigsService: FuellingReplanningConfigsService) {
  }

  public ngOnInit(): void {
    this.idSubs = this.route.params
      .pipe(takeUntil(this.subSubject))
      .subscribe(() => {
        this.vehicle = this.route.snapshot.params.id;
        this.vehicleSubs = this.latestVehiclesInfoService.vehicleInfos()
          .pipe(first(), takeUntil(this.subSubject))
          .subscribe((vehicles) => {
              this.latestVehicles = [...vehicles];
              this.load();
            }
          );
        this.globalService.newLatestSubscription(); // todo ignas remov latest
      });

    this.isMobile = this.deviceService.isMobile();
    this.routeParamsActive = !this.isMobile;

    this.searchSubs = this.searchSubject.pipe(
      debounceTime(500),
      takeUntil(this.subSubject)
    ).subscribe((data) => this.search(data.idx, data.keyword));

    this.clickListener = this.renderer.listen('window', 'click', (_e: Event) => {
      this.hideShowMore(-1);
      this.searchResult = [];
    });
    this.routeChangesSubs = this.formStateService.routeChanges()
      .pipe(takeUntil(this.subSubject))
      .subscribe(
        (form) => {
          this.routeChanged(form);
          this.formStateService.triggerReloadFuel(this.forms);
          this.formStateService.triggerReloadParkings(this.forms);
          this.cd.markForCheck();
        }
      );
    this.routeInfosSubs = this.formStateService.generateRouteInfo()
      .pipe(takeUntil(this.subSubject))
      .subscribe((data) => {
        this.formRouteInfo(data, false)
        this.activeRouteCO2Emission = this.calculateCO2Emission(data.controls.distance.value)
      });

    this.formStateService.serviceInsertReset()
      .pipe(takeUntil(this.subSubject))
      .subscribe(() => this.resetServiceInsert());

    this.taskSubs = this.formStateService.insertTaskFromPOI()
      .pipe(takeUntil(this.subSubject))
      .subscribe((data) => {
        if (this.formsLoaded) {
          this.addTaskFromMarker(data);
        } else {
          this.poiInsertTask = data;
        }
      });

    this.oldTaskSubs = this.route.queryParams
      .pipe(takeUntil(this.subSubject))
      .subscribe(
        (params) => {
          if (params.oldTask != null) {
            this.processOldTaskRequest(params.oldTask, params.edit, params.idx, params.formType);
          }
        });
    this.routeCostSubs = this.formStateService.recalculateRouteInfo()
      .pipe(takeUntil(this.subSubject))
      .subscribe(() => this.recalculatePlanningRouteInfo());

    this.stateService.toggleRoutePlanner()
      .pipe(takeUntil(this.subSubject))
      .subscribe((data) => this.routePlannerActive = data);

    this.olRouteService.getOlDirections()
      .pipe(takeUntil(this.subSubject))
      .subscribe((data) => {
        this.routePlannerActive = !!data
        this.cd.detectChanges();
      });

    this.multiTemplateSubs = this.formStateService.appendFromTemplate()
      .pipe(takeUntil(this.subSubject))
      .subscribe((details) => this.appendFromTemplate(details));

    this.markedPaidRoadsTollsSubs = this.formStateService.markedPaidRoadsTollsObservable()
      .pipe(takeUntil(this.subSubject))
      .subscribe(
        (tollsData) => {
          let form = this.forms.find(it => it.controls.uuid.value === tollsData.uuid);
          if (form) {
            form.patchValue({markedRoadsTolls: tollsData.tolls});
            this.recalculatePlanningRouteInfo();
            this.cd.markForCheck();
          }
        }
      );

    this.formStateService.enableTasksFormsSave()
      .pipe(takeUntil(this.subSubject))
      .subscribe({
        next: () => {
          this.routeReloading = false;
          this.cd.detectChanges();
        }
      });

    this.getTaskPlannerConfigs();

    this.driverLangSub = this.managerService.driverLanguage(this.vehicle)
      .pipe(takeUntil(this.subSubject))
      .subscribe({
        next: (data) => this.driverLang = data,
        error: () => this.notification.loadingError()
      });

    this.globalService.getTimeZones()
      .pipe(takeUntil(this.subSubject))
      .subscribe((data) => this.zones = data);

    this.getIsAutomaticReplanning();
  }

  public load(): void {
    this.formsLoaded = false;
    if (this.reset == null) {
      this.managerService.load(this.vehicle)
        .pipe(takeUntil(this.subSubject))
        .subscribe({
          next: (data) => this.processForms(data, false),
          error: () => this.notification.loadingError()
        });
    } else {
      const filteredVehicle = this.latestVehicles.filter(vehicle => vehicle.id === +this.vehicle)[0];
      let fuelLevel = filteredVehicle != null ? filteredVehicle.fuel : null;
      this.managerService.loadReset(this.vehicle, this.reset, fuelLevel)
        .pipe(takeUntil(this.subSubject))
        .subscribe({
          next: (data) => this.processForms(data, true),
          error: () => this.notification.loadingError()
        });
    }
  }

  private processForms(data: ProTasksEditEntry, reset: boolean) {
    this.data = data;
    this.setLastTaskInfo(data.forms);
    this.latLngToFixed(this.data.forms);
    this.averageFuelPrice = data.averageFuelPrice;
    this.averageTruckRentPrice = data.averageTruckRentPrice;
    Object.keys(data.taskTypesDurations).forEach(key => {
      this.taskTypesDuration.set(key, data.taskTypesDurations[key]);
    });
    this.data.currentTasks.sort((a, b) => a.idx > b.idx ? 1 : -1);
    this.latestVehicles.push(data.vehicle);
    this.managerService.options()
      .pipe(takeUntil(this.subSubject))
      .subscribe(
        (options) => {
          this.setupAdditionalOptions(options);
          let formsDTO = data.forms;
          let sorted = formsDTO.sort((a, b) => a.idx > b.idx ? 1 : -1);
          sorted.forEach(it => it.idx = sorted.indexOf(it));
          this.forms = sorted.map(it => this.toForm(it));
          if (this.forms.length === 0) {
            this.forms.push(this.newForm());
            this.activeForm = this.forms[0];
          } else {
            this.activeForm = this.forms[0];
            if (reset) {
              let firstForm = this.forms[0];
              this.reassignOrigins(firstForm.controls.origin.value, firstForm.controls.originPosition.value, true);
              this.formStateService.reloadAll({
                shouldRecenter: true,
                formIdx: null,
                forms: this.forms
              });
            } else {
              this.formStateService.postForms(this.forms);
            }
          }
          setTimeout(() => {
            this.formStateService.triggerActiveForm(this.activeForm)
            this.detectFuelOptionValue();
          }, 250);
          this.detectTaskTypeChange();
          this.getFuelConsumptionAndCheckWarning();
          this.forms.forEach(form => this.handleFerryTrainType(form, this.forms.indexOf(form), false, true));
          if (this.lkwOrder != null) {
            setTimeout(() => this.handleLKWOrder(), 250);
          }
          if (this.optimalFuelling && this.optimalFuelling.length) {
            setTimeout(() => this.handleOptimalFuelling(), 250);
          }
          if (this.suggestReplan) {
            setTimeout(() => this.suggestPlan(false), 250);
          }
          this.formsLoaded = true;
          this.serviceInsertSnapshot = null;
          this.formStateService.triggerServiceInserted(null);
          if (this.poiInsertTask != null) {
            this.addTaskFromMarker(this.poiInsertTask);
          }
          this.cd.markForCheck();
        });
  }

  public typeInConfigs(type: string): boolean {
    return this.taskTypes.includes(type);
  }

  public getDropdownDefaultSelectName(type: string): string {
    return this.translate.instant(type !== null ? 'proTasks.type.' + type : 'proTasks.type.title');
  }

  private setupAdditionalOptions(options: InfoOptionEntry[]): void {
    this.additionalInfoConfigs = this.getFilteredAdditionalOptionsConfigs();
    this.additionalOptions = options.sort((a, b) => a.id > b.id ? -1 : 1);
  }

  private setLastTaskInfo(forms: ProTaskForm[]): void {
    if (forms.length > 0) {
      this.previousTasks = forms.map(it => it.id);
      let lastModifications = forms.filter(it => it.lastModification != null)
        .map(it => it.lastModification);
      if (lastModifications?.length > 0) {
        lastModifications.sort((a, b) => a > b ? -1 : 1);
        this.lastKnownModification = lastModifications[0];
      } else {
        this.lastKnownModification = null;
      }
    }
  }

  private getFilteredAdditionalOptionsConfigs(): number[] {
    let additionalInfoConfigs = AuthStorage.getTasksConfigs().additionalInfoIds ?? [-1, -2, -3, -4, -5, -6, -7];
    let filteringRequired = additionalInfoConfigs.filter(id => FREEZERS_IDS.includes(id)).length > 0;
    if (filteringRequired) {
      let vehicle = this.latestVehicles.find(it => it.id === +this.vehicle);
      if (!this.hasTemperature(vehicle)) {
        additionalInfoConfigs = additionalInfoConfigs.filter(
          id => id !== TEMPERATURE_LOW_ID && id !== TEMPERATURE_HIGH_ID);
      }
      if (!this.hasSecondCompartmentTemperature(vehicle)) {
        additionalInfoConfigs = additionalInfoConfigs.filter(
          id => id !== SECOND_TEMPERATURE_LOW_ID && id !== SECOND_TEMPERATURE_HIGH_ID);
      }
    }
    return additionalInfoConfigs;
  }

  private hasTemperature(vehicle: LatestVehicleEntry): boolean {
    if (vehicle != null) {
      return vehicle.hasFreezer
        || vehicle.connectedTrailer != null
        && vehicle.connectedTrailer.actualFreezerTemperature != null
    }
    return false;
  }

  private hasSecondCompartmentTemperature(vehicle: LatestVehicleEntry): boolean {
    if (vehicle != null) {
      return vehicle.hasFreezer
        || vehicle.connectedTrailer != null
        && vehicle.connectedTrailer.secondCompartmentTemperature != null
    }
    return false;
  }

  private detectTaskTypeChange() {
    SubscriptionUtils.safeUnsubscribe(this.formValueChangeSubs);
    let taskType = this.activeForm.get('type');
    this.formValueChangeSubs = taskType
      .valueChanges
      .pipe(startWith(taskType.value), pairwise(), takeUntil(this.subSubject))
      .subscribe(([previousValue, newValue]: [string, string]) => {
        this.handleTrainAndFerries(newValue, previousValue);
        this.detectCabotageViolation(newValue, previousValue);
      })
  }

  private handleTrainAndFerries(newValue, previousValue) {
    let ferryType = EnumValues.getNameFromValue(TaskTypes, TaskTypes.FERRY);
    let trainType = EnumValues.getNameFromValue(TaskTypes, TaskTypes.TRAIN);
    let nextTaskIdx = this.activeFormIdx + 1;
    let nextTask = this.forms[nextTaskIdx];
    if ((newValue === ferryType || newValue === trainType) && nextTask != null) {
      this.enableOriginInput(nextTask, nextTaskIdx, true, false);
    } else if ((previousValue === ferryType || previousValue === trainType) && nextTask != null) {
      this.disableOriginInput(nextTask, nextTaskIdx, true);
    }
  }

  private detectCabotageViolation(newValue: string, previousValue?: string) {
    const unloadingType = EnumValues.getNameFromValue(TaskTypes, TaskTypes.UNLOADING);
    if (this.canUseCabotage(newValue, unloadingType, previousValue)) {
      this.managerService.detectCabotageViolation(this.vehicle, this.getUnsavedTasks())
        .pipe(takeUntil(this.subSubject))
        .subscribe((showWarning) => this.formStateService.triggerCabotageWarning(showWarning));
    }
  }

  private canUseCabotage(newValue: string, unloadingType: string, previousValue: string) {
    let clientId = AuthStorage.getClientId();
    const clientsAllowedToUse = [6600, 6601, 6450, 6151] // Transmeja and Hoptransa clients ids
    return (newValue === unloadingType || previousValue === unloadingType)
      && clientsAllowedToUse.includes(clientId)
      && environment.production;
  }

  private getUnsavedTasks() {
    let filteredTasks = this.forms.filter(it => it.controls.id.value == null
      && it.controls.destinationPosition.valid
      && (it.controls.type.value === 'UNLOADING' || it.controls.type.value === 'LOADING'));
    if (filteredTasks.length <= 0) {
      return [{
        idx: this.activeForm.controls.idx.value,
        type: this.activeForm.controls.type.value,
        position: this.activeForm.controls.destinationPosition.value
      }]
    }
    return filteredTasks.map(it => {
      return {
        idx: it.controls.idx.value,
        type: it.controls.type.value,
        position: it.controls.destinationPosition.value
      }
    });
  }

  public notValid(control: AbstractControl): boolean {
    for (let propertyName in control.errors) {
      if (control.errors.hasOwnProperty(propertyName)) {
        return true;
      }
    }
    return false;
  }

  public activateForm(idx: number, $event: any, input: number, fireSearch: boolean, activeType: string) {
    this.activeForm = this.forms[idx];
    this.activeFormIdx = idx;
    this.activeType = activeType
    this.formStateService.triggerActiveForm(this.activeForm);
    if (fireSearch) {
      let keyword = $event.clipboardData.getData('Text');
      this.handlePasteEvent(keyword, input, $event);
    }
    setTimeout(() => {
      this.detectFuelOptionValue();
    }, 200);
    this.detectTaskTypeChange();
    this.recalculatePlanningRouteInfo();
    this.activeRouteCO2Emission = this.calculateCO2Emission(this.activeForm.controls.distance.value);
    this.cd.markForCheck();
  }

  private routeChanged(form: UntypedFormGroup) {
    let index = form.controls.idx.value;
    this.forms.splice(index, 1);
    this.forms.push(form);
    this.forms.sort((a, b) => a.controls.idx.value > b.controls.idx.value ? 1 : -1);
    this.activeForm = this.forms[index];
    this.activeFormIdx = index;
    this.formRouteInfo(this.activeForm, false);
  }

  public formRouteInfo(form: UntypedFormGroup, typeChanging: boolean): void {
    if (typeChanging) {
      this.patchTaskDuration(form);
      if (form.value.destinationPosition) {
        this.formStateService.triggerReloadTaskMarker(form);
        this.formStateService.triggerReloadFuel(this.forms);
        this.deleteTank(FUEL_ADDITIONAL_ID);
        this.deleteTank(ADBLUE_ADDITIONAL_ID);
        if (this.keepSameTemperature) {
          this.copyTemperatureAdditionalOptions(form);
        }
      }
    }
    this.managerService.translationFile(this.driverLang)
      .pipe(takeUntil(this.subSubject))
      .subscribe(
        (translations) => {
          let type = TaskUtils.typeTranslation(form.controls.type.value, translations);
          let routeInfo: string = form.controls.routeInfo.value;
          if (!typeChanging) {
            let dest = form.controls.destinationPosition.value;
            let coordinates =
              `${translations.tasks.manager.form.comment.coordinates} ${dest.lat.toFixed(7)}, ${dest.lng.toFixed(7)}`;
            let roadsString =
              `${translations.tasks.manager.form.comment.roads} ${form.controls.roads.value}`;
            let distanceStr = translations.tasks.manager.form.comment.distance;
            let place = translations.tasks.manager.form.comment.place;
            let distance =
              `${`${distanceStr} ${place}`} ${Math.round(form.controls.distance.value / 1000)} km.`;
            routeInfo = `${type}: ${form.controls.destination.value}.\n${coordinates}.\n${roadsString}.\n${distance}`;
          } else {
            if (routeInfo != null) {
              let withoutType = routeInfo.substring(routeInfo.indexOf(':'));
              routeInfo = type + withoutType;
            }
          }
          form.patchValue({routeInfo: routeInfo});
          this.determineFuelWarning();
          if (!this.cd['destroyed']) {
            this.cd.detectChanges();
          }
        });
  }

  private patchTaskDuration(form: UntypedFormGroup) {
    if (form.controls.id.value === null) {
      form.controls.durationItself?.patchValue(this.taskTypesDuration.get(form.controls.type.value));
    }
  }

  private copyTemperatureAdditionalOptions(targetForm: UntypedFormGroup): void {
    const loadingForms = this.forms.filter(form => form.value.type === 'LOADING'
      && form.value.idx <= targetForm.value.idx);
    if (loadingForms.length !== 0) {
      const prevLoadingForm = this.findLoadingFormBreakpoint(loadingForms, false);
      const type = targetForm.value.type;
      if (type === 'LOADING' && ((targetForm.value.idx-1) !== prevLoadingForm.value.idx)) {
        this.updateTemperatures(targetForm);
      } else {
        this.moveTemperatureData(prevLoadingForm, targetForm);
      }
    }
  }

  private findLoadingFormBreakpoint(forms: UntypedFormGroup[], first: boolean): UntypedFormGroup {
    let currentRunStartIdx = 0;
    let prev = forms[0].value.idx;

    for (let i = 1; i < forms.length; i++) {
      const curr = forms[i].value.idx;
      if (curr - prev > 1) {
        currentRunStartIdx = i;
        if (first) {
          break;
        }
      }
      prev = curr;
    }

    return forms[currentRunStartIdx];
  }

  private moveTemperatureData(from: UntypedFormGroup, to: UntypedFormGroup): void {
    this.moveAdditionalInfoValue(FREEZER_MODE_ID, from, to, true);
    this.moveAdditionalInfoValue(FREEZER_TEMPERATURE_ID, from, to, true);
    this.moveAdditionalInfoValue(FREEZER_SECOND_COMPARTMENT_TEMPERATURE_ID, from, to, true);
  }

  public drop(event: any) {
    this.clearEtas();
    let previous = event.previousIndex;
    let current = event.currentIndex;
    let ferryType = EnumValues.getNameFromValue(TaskTypes, TaskTypes.FERRY);
    let trainType = EnumValues.getNameFromValue(TaskTypes, TaskTypes.TRAIN);
    if (previous !== current) {
      let firstForm = this.forms[0];
      if (current === 0 && firstForm?.value.status === 'EXECUTING') {
        this.traveledDistance = firstForm.value.distanceRemaining != null
        && firstForm.value.distance >= firstForm.value.distanceRemaining
          ? firstForm.value.distance - firstForm.value.distanceRemaining
          : 0;
      }
      let origin = firstForm.controls.origin.value;
      let originPosition = firstForm.controls.originPosition.value;
      this.removePreviousOriginInputs(ferryType, trainType);
      this.moveTaskOriginAfterTrainAndFerry(previous, current, ferryType, ferryType);
      moveItemInArray(this.forms, previous, current);
      this.forms.forEach(it => it.patchValue({idx: this.forms.indexOf(it)}));
      this.reassignTrainsAndFerriesTypes(ferryType, trainType);
      this.reassignOrigins(origin, originPosition, true);
      if (this.forms[current].controls.destinationPosition.value != null) {
        this.formStateService.reloadAll({
          shouldRecenter: true,
          formIdx: null,
          forms: this.forms
        });
      }
    }
  }

  private moveTaskOriginAfterTrainAndFerry(previous: number,
                                           current: number,
                                           ferryType: string,
                                           trainType: string): void {

    if (this.isTaskBeforeTrainOrFerry(current, ferryType, trainType)) {
      this.moveTaskOrigin(current, previous);
    }
    if (this.isTaskBeforeTrainOrFerry(previous, ferryType, trainType)) {
      this.moveTaskOrigin(previous, current);
    }
  }

  private isTaskBeforeTrainOrFerry(index: number, ferryType: string, trainType: string): boolean {
    let type = this.forms[index - 1]?.value.type;
    return ferryType === type || trainType === type;
  }

  private moveTaskOrigin(fromIndex: number, toIndex: number): void {
    let fromTask = this.forms[fromIndex];
    let toTask = this.forms[toIndex];
    toTask.patchValue({
      origin: fromTask.value.origin,
      originPosition: fromTask.value.originPosition
    });
  }

  private removePreviousOriginInputs(ferryType: string, trainType: string) {
    let filteredForms = this.forms
      .filter(form => form.controls.type.value === ferryType || form.controls.type.value === trainType);
    for (const form of filteredForms) {
      let nextTaskIdx = this.forms.indexOf(form) + 1;
      let nextTask = this.forms[nextTaskIdx];
      if (nextTask != null) {
        this.disableOriginInput(nextTask, nextTaskIdx, false);
      }
    }
  }

  private reassignTrainsAndFerriesTypes(ferryType: string, trainType: string) {
    let filteredForms = this.forms
      .filter(form => form.controls.type.value === ferryType || form.controls.type.value === trainType);
    for (const form of filteredForms) {
      let nextTaskIdx = this.forms.indexOf(form) + 1;
      let nextTask = this.forms[nextTaskIdx];
      if (nextTask != null) {
        this.enableOriginInput(nextTask, nextTaskIdx, false, false);
      }
    }
  }

  private reassignOrigins(
    previousOrigin: string,
    previousOriginPosition: MapPosition,
    reset: boolean) {

    for (let form of this.forms) {
      let reassignOrigin = this.formsIdxWithDifferentOrigins.find(it => it === this.forms.indexOf(form));
      if (reassignOrigin == null) {
        let previousAddress = previousOrigin;
        let previousPosition = previousOriginPosition;
        if (form.controls.idx.value !== 0) {
          let previousForm = this.forms[this.forms.indexOf(form) - 1];
          previousAddress = previousForm.controls.destination.value;
          previousPosition = previousForm.controls.destinationPosition.value;
          if (reset) {
            this.resetWaypoints(form, previousPosition);
          }
        }
        let formPosition = form.controls.originPosition.value;
        if (formPosition != null && previousPosition != null &&
          (formPosition.lat !== previousPosition.lat && formPosition.lng !== previousPosition.lng)) {
          this.resetFormStatus(form);
        }
        form.patchValue({
          origin: previousAddress,
          originPosition: previousPosition
        });
      }
    }
  }

  private resetWaypoints(form: UntypedFormGroup, previousPosition: MapPosition) {
    let currentPosition = form.controls.originPosition.value;
    if ((currentPosition != null && previousPosition != null)
      && (currentPosition.lat !== previousPosition.lat || currentPosition.lng !== previousPosition.lng)) {

      form.patchValue({
        waypoints: []
      });
    }
  }

  public save(confirmTasks: boolean) {
    if (this.areFormsValid() && !this.saveInProgress) {
      this.saveInProgress = true;
      this.managerService.haveTasksChanged(this.vehicle, this.previousTasks, this.lastKnownModification)
        .pipe(takeUntil(this.subSubject))
        .subscribe({
          next: (tasksChanged) => {
            if (tasksChanged) {
              let popup = this.modalService.open(TaskConfirmComponent)
              popup.result.then(
                () => this.doSave(confirmTasks),
                () => this.cancel()
              );
            } else {
              this.doSave(confirmTasks);
            }
          },
          error: () => this.doSave(confirmTasks)
        });
    }
  }

  private doSave(confirmTasks: boolean): void {
    this.forms = this.forms.filter(it => it.controls.legs.value != null);
    this.forms.forEach(it => it.patchValue({idx: this.forms.indexOf(it)}));
    const saveTaskPromise = async () => this.saveTasks(confirmTasks);
    saveTaskPromise().then(() => this.saveInProgress = false).catch(() => this.saveInProgress = false);
  }

  private async saveTasks(confirmTasks: boolean) {
    await lastValueFrom(this.managerService.save(
      this.vehicle,
      this.forms,
      confirmTasks,
      this.fuelWarning,
      this.enabledDefaultWaypoints,
      this.copyEnabled,
      this.driverLang,
      this.lkwOrder != null ? this.lkwOrder.id : null,
      this.selectedUnveroStation)
      .pipe(takeUntil(this.subSubject)))
      .then(() => {
        let index = 0;
        if (this.files.size > 0) {
          this.files.forEach((value, key) => {
            index++;
            this.managerService.saveFile(key, value, this.vehicle)
              .pipe(takeUntil(this.subSubject))
              .subscribe({
                next: () => {
                  if (index === this.files.size) {
                    this.notification.savingSuccess();
                    this.saves.emit();
                  }
                },
                error: (err) => {
                  this.notification.info(err.status === 415
                    ? 'global.error.unsupported-media-type'
                    : 'File saving error'
                  );
                  this.saves.emit();
                }
              });
          });
        } else {
          this.notification.savingSuccess();
          this.saves.emit();
        }
        this.cookieService.put(TASKS_ALTERNATIVES, this.activeForm.controls.alternatives.value);
        this.cookieService.put(TASKS_TRAFFIC, this.activeForm.controls.traffic.value);
        this.cookieService.put(TASKS_INCIDENTS, this.activeForm.controls.incidents.value);
        this.cookieService.put(TASKS_BAD_MARKED_ROADS, this.activeForm.controls.badMarkedRoads.value);
        this.cookieService.put(TASKS_CONDITIONAL_RESTRICTIONS, this.activeForm.controls.conditionalRestrictions.value);
        this.cookieService.put(
          TASKS_EXCLUDED_COUNTRIES,
          JSON.stringify(this.activeForm.controls.excludedCountries.value));
      })
      .catch(() => this.notification.storingError());
  }

  public cancel(): void {
    this.cancels.emit();
    this.saveInProgress = false
  }

  public areFormsValid(): boolean {
    let valid = true;
    for (let form of this.forms) {
      if (!form.valid) {
        valid = false;
      }
    }
    return valid && !this.routeReloading;
  }

  /*--------------------------------------------------Add / remove ---------------------------------------------------*/

  public addTask(): void {
    this.addNewTask(this.emptyForm());
    this.formStateService.triggerMapRecenter(null);
  }

  public addNewTask(newForm: UntypedFormGroup): void {
    this.clearEtas();
    this.forms.push(newForm);
    this.activeForm = newForm;
    this.activeFormIdx = newForm.controls.idx.value;
    this.planningRouteCost = null;
    this.activeRouteCO2Emission = 0;
    this.handleFerryTrainType(newForm, this.activeFormIdx, true, false);
  }

  private handleFerryTrainType(form: UntypedFormGroup, idx: number, newForm: boolean, init: boolean) {
    let previousForm = this.forms[idx - 1];
    let ferryType = EnumValues.getNameFromValue(TaskTypes, TaskTypes.FERRY);
    let trainType = EnumValues.getNameFromValue(TaskTypes, TaskTypes.TRAIN);
    if (previousForm != null
      && (previousForm.controls.type.value === ferryType || previousForm.controls.type.value === trainType)) {
      this.enableOriginInput(form, idx, newForm, init);
    }
  }

  private enableOriginInput(form: UntypedFormGroup, idx: number, newForm: boolean, init: boolean) {
    let origin = !newForm ? form.controls.origin.value : null;
    let originPosition = !newForm ? form.controls.originPosition.value : null;
    form.patchValue({
      origin: origin,
      originPosition: originPosition,
    });
    setTimeout(() => {
      let element = document.getElementById(`form-origin-${idx}`);
      if (element != null) {
        element.classList.remove('hidden');
        element.style.setProperty('border-right', '1px solid rgba(0,0,0,.15)', 'important');
        element.style.setProperty('display', 'flex', 'important');
      }
      this.cd.markForCheck();
    }, 250);
    ArrayUtils.addElementIfNotExists(this.formsIdxWithDifferentOrigins, idx)
    if (!init) {
      this.resetFormStatus(form);
    }
  }

  private disableOriginInput(form: UntypedFormGroup, idx: number, formReloadNeeded: boolean) {
    let element = document.getElementById(`form-origin-${idx}`);
    let previousForm = this.forms[idx - 1];
    if (element != null && previousForm != null) {
      element.style.removeProperty('border-right');
      element.style.removeProperty('display');
      element.classList.add('hidden')
      ArrayUtils.removeElement(this.formsIdxWithDifferentOrigins, idx)
      if (formReloadNeeded) {
        form.patchValue({
          origin: previousForm.controls.destination.value,
          originPosition: previousForm.controls.destinationPosition.value,
        });
        this.formStateService.reloadForm(form);
        this.formStateService.triggerTrainOrFerryRemoval(form.controls.uuid.value);
      }
    }
  }

  private addTaskFromMarker(data: PoiInsertTask) {
    this.clearEtas();
    this.snapshotBeforeServiceInsert(data);
    this.routeReloading = true;
    this.removeWithoutDestinationExceptFirst();
    if (this.forms.length === 1 && this.forms[0].controls.destinationPosition.value === null) {
      this.addDestination(data, this.forms[0]);
    } else {
      let ferryType = EnumValues.getNameFromValue(TaskTypes, TaskTypes.FERRY);
      let trainType = EnumValues.getNameFromValue(TaskTypes, TaskTypes.TRAIN);
      this.removePreviousOriginInputs(ferryType, trainType);
      let isLastPositionWithNoEmptyForms = data.importSelected && this.forms[this.activeFormIdx] == null;
      if (!data.lastPosition && !isLastPositionWithNoEmptyForms) {
        let index = data.importSelected
          ? this.activeFormIdx
          : ProTasksFormRouteUtils.getNewTaskIndex(this.forms, data.lat, data.lng, this.data.vehicle.position);
        let firstForm = this.forms[0];
        let origin = firstForm.controls.origin.value;
        let originPosition = firstForm.controls.originPosition.value;
        const form = index < this.forms.length
          ? this.forms[index]
          : this.forms[this.forms.length - 1];
        let newForm = index === 0 ? this.insertNewForm(this.forms[0]) : this.emptyForm();
        if (index === 0 && executing(this.forms[index].value.status)) {
          this.traveledDistance = this.forms[index].value.distanceRemaining != null
          && this.forms[index].value.distance >= this.forms[index].value.distanceRemaining
            ? this.forms[index].value.distance - this.forms[index].value.distanceRemaining
            : 0;
        }
        let previousFormType = this.forms[index - 1]?.value.type;
        if (previousFormType != null && (previousFormType == trainType || previousFormType == ferryType)) {
          this.changeOrigin(form, newForm);
        }
        newForm.controls.preferableRouteApplied.setValue(form.controls.preferableRouteApplied.value);
        this.addDestination(data, newForm);
        this.forms.splice(index, 0, newForm);
        this.forms.forEach(it => it.patchValue({idx: this.forms.indexOf(it)}));
        setTimeout(() => {
          this.setUpWayPoints(form, index, data.lat, data.lng);
          this.handleUnvero(data, newForm);
          this.activeForm = newForm;
          this.activeFormIdx = this.forms[index].controls.idx.value;
          this.reassignTrainsAndFerriesTypes(ferryType, trainType);
          this.reassignOrigins(origin, originPosition, false);
        });
      } else {
        if (this.forms.length > 0 && executing(this.forms[0].value.status)) {
          this.traveledDistance = this.forms[0].value.distanceRemaining != null
          && this.forms[0].value.distance >= this.forms[0].value.distanceRemaining
            ? this.forms[0].value.distance - this.forms[0].value.distanceRemaining
            : 0;
        }
        let latestFormIdx = this.forms.length;
        let newForm = this.emptyForm();
        let previousFormType = this.forms[latestFormIdx - 1]?.value.type;
        if (previousFormType != null && (previousFormType == trainType || previousFormType == ferryType)) {
          let latestForm = this.forms[latestFormIdx];
          this.changeOrigin(latestForm, newForm)
        }
        this.addDestination(data, newForm);
        this.forms.push(newForm);
        this.forms.forEach(it => it.patchValue({idx: this.forms.indexOf(it)}));
        this.handleUnvero(data, newForm);
        this.activeForm = newForm;
        this.activeFormIdx = newForm.controls.idx.value;
        this.reassignTrainsAndFerriesTypes(ferryType, trainType);
      }
    }
    setTimeout(() => {
      this.formStateService.reloadAll({
        shouldRecenter: true,
        formIdx: this.activeFormIdx,
        forms: this.forms
      });
      this.formStateService.triggerActiveForm(this.activeForm);
      this.detectTaskTypeChange();
      this.determineFuelWarning();
    }, 250);
    this.cd.detectChanges();
    this.poiInsertTask = null;
  }

  private removeWithoutDestinationExceptFirst(): void {
    let formsWithDestination = this.forms.filter(it => it.controls.destinationPosition.value != null);
    this.forms = formsWithDestination.length > 0
      ? formsWithDestination
      : this.forms.filter((it, idx) => idx === 0 || it.controls.destinationPosition.value != null);
  }

  private handleUnvero(data: PoiInsertTask, newForm: UntypedFormGroup): void {
    if (data.unveroData) {
      this.selectedUnveroStation = data.unveroData;
      this.moveAdditionalInfoValue(FUEL_ADDITIONAL_ID, this.activeForm, newForm);
      this.moveAdditionalInfoValue(ADBLUE_ADDITIONAL_ID, this.activeForm, newForm);
    }
  }

  private setUpWayPoints(form: UntypedFormGroup, index: number, lat: number, lng: number) {
    if (form != null && form.controls.waypoints.value.length > 0) {
      let sortedWayPoints = ProTasksFormRouteUtils.getSortedWayPoints(form, lat, lng);
      this.forms[index + 1].patchValue({waypoints: TaskUtils.latLngToMapPositions(sortedWayPoints.new)})
      this.forms[index].patchValue({waypoints: TaskUtils.latLngToMapPositions(sortedWayPoints.old)})
    }
  }

  private addDestination(data: PoiInsertTask, newForm: UntypedFormGroup) {
    if (data.contactlessType != null && data.contactlessType !== 'null' && data.contactlessType !== 'undefined') {
      newForm.patchValue({
        externalPoiId: data.externalId,
        contactlessType: data.contactlessType
      });
    }
    if (data.parkingType != null && data.parkingType !== 'null' && data.parkingType !== 'undefined') {
      newForm.patchValue({
        parkingType: data.parkingType,
        parkingId: data.externalId
      });
    }
    if (data.poiId != null && Number.isInteger(+data.poiId)) {
      newForm.patchValue({
        poiId: data.poiId
      })
    }
    if (data.durationItself != null) {
      newForm.patchValue({
        durationItself: data.durationItself
      });
    }
    if (data.planningServiceId != null) {
      newForm.patchValue({
        planningServiceId: data.planningServiceId
      });
    }
    if (data.comment !== 'null'
      && data.comment !== 'undefined'
      && data.comment !== 'NaN'
      && data.comment != null) {
      const mergedComment = data.name
        ? `${data.name} - ${data.comment}`
        : data.comment;
      newForm.patchValue({ comments: mergedComment });
    }
    if (data.type !== 'null' && data.type !== 'undefined' && data.type != null) {
      newForm.patchValue({type: data.type})
    }
    if (data.emails !== 'null' && data.emails !== 'undefined' && data.emails != null) {
      this.patchOption(newForm, data.emails, -7);
    }

    let destination;
    if (data.name != null && data.name !== 'null' && data.name !== 'undefined') {
      destination = data.name;
    } else if (data.address != null) {
      destination = data.address;
    } else {
      destination = data.lat.toString() + ', ' + data.lng.toString();
    }
    newForm.patchValue({
      destination: destination
    });

    newForm.controls.destinationPosition.patchValue({
      lat: data.lat,
      lng: data.lng,
      address: data.address != null ? data.address : ''
    });

    if (data.lkwItem != null) {
      let item: LkwItem = data.lkwItem;
      let orderNumber: string = data.lkwOrderNumber;
      this.patchOption(newForm, orderNumber, ORDER_ADDITIONAL_ID)
      this.patchOption(newForm, item.dateFrom + ' - ' + item.dateTo, LOAD_TIME_ADDITIONAL_ID)
      this.patchOption(newForm, item.weight, CARGO_WEIGHT_ADDITIONAL_ID)
      this.patchOption(newForm, item.goods, KIND_OF_GOODS_ADDITIONAL_ID)
      newForm.patchValue({
        type: this.resolveLkwItemTaskType(item.type),
        destination: item.address,
        comments: this.formLkwItemComment(item.info, data.position)
      })
    }
  }

  private formLkwItemComment(info: string, position: string): string {
    let comment = '';
    if (position) {
      comment += 'LKW Walter: ' + position + '\n'
    }
    if (info) {
      comment += info;
    }
    return comment;
  }

  private resolveLkwItemTaskType(type: string): string {
    switch (type) {
      case 'LOADING':
      case 'ARRIVAL_TERMINAL':
      case 'DEPOT_PICKUP':
        return 'LOADING'
      case 'UNLOADING':
      case 'DEPARTURE_TERMINAL':
      case 'DEPOT_DROPOFF':
        return 'UNLOADING'
      case 'IMPORT':
      case 'EXPORT':
      case 'TRANSIT':
      case 'CUSTOMS_IMPORT':
      case 'CUSTOMS_EXPORT':
      case 'CUSTOMS_TRANSIT':
        return 'CUSTOMS'
      default :
        return 'OTHER'
    }
  }

  private patchOption(newForm: UntypedFormGroup, textValue: any, optionIdx: number) {
    let additionalOptions = this.getAdditionalOptions(newForm);
    let index = this.getFormOptionIndex(optionIdx, newForm);
    if (index !== -1) {
      additionalOptions.at(index).patchValue({value: textValue});
    }
  }

  private changeOrigin(form: UntypedFormGroup, newForm: UntypedFormGroup) {
    if (form != null) {
      newForm.patchValue({
        origin: form.controls.origin.value,
        originPosition: form.controls.originPosition.value,
      });
    }
  }

  private addOrigin(data: any, form: UntypedFormGroup) {
    form.patchValue({
      origin: data.address != null ? data.address : data.lat.toString() + ', ' + data.lng.toString()
    });
    form.controls.originPosition.patchValue({
      lat: data.lat,
      lng: data.lng,
      address: data.address != null ? data.address : ''
    });
  }

  public delete(form: UntypedFormGroup): void {
    if (!this.routeReloading) {
      this.clearEtas();
      this.routeReloading = true;
      let firstForm = this.forms[0];
      let origin = firstForm.controls.origin.value;
      let originPosition = firstForm.controls.originPosition.value;
      let ferryType = EnumValues.getNameFromValue(TaskTypes, TaskTypes.FERRY);
      let trainType = EnumValues.getNameFromValue(TaskTypes, TaskTypes.TRAIN);
      this.removePreviousOriginInputs(ferryType, trainType);
      let formIndex = this.forms.indexOf(form);
      if (this.isTaskBeforeTrainOrFerry(formIndex, ferryType, trainType)) {
        if (formIndex < this.forms.length && formIndex != this.forms.length - 1) {
          this.moveTaskOrigin(formIndex, formIndex + 1);
        }
      }
      this.forms.splice(formIndex, 1);
      this.forms.forEach(it => it.patchValue({idx: this.forms.indexOf(it)}));
      this.reassignTrainsAndFerriesTypes(ferryType, trainType);
      this.reassignOrigins(origin, originPosition, false);
      this.activateForm(0, null, 0, false, 'DESTINATION');
      this.formStateService.reloadAll({
        shouldRecenter: true,
        formIdx: null,
        forms: this.forms
      });
      this.determineFuelWarning();
      this.detectCabotageViolation(EnumValues.getNameFromValue(TaskTypes, TaskTypes.UNLOADING))
    }
  }

  public resetFormStatus(form: UntypedFormGroup) {
    form.patchValue({status: 'UNCONFIRMED'});
  }

  public removeFormWaypoints(form: UntypedFormGroup) {
    form.patchValue({
      waypoints: []
    });
    this.formStateService.reloadForm(form);
  }

  /*--------------------------------------------------Address search--------------------------------------------------*/

  public search(idx: number, keyword: string) {
    this.keyword = keyword;
    if (this.keyword) {
      let sources = [
        PlaceSource.NOMINATIM_COORDINATES,
        PlaceSource.VEHICLES,
        PlaceSource.DRIVERS,
        PlaceSource.POI];

      if (this.keyword.length > 3) {
        if (this.keyword.match(POST_CODE_REGEX)) {
          sources.push(PlaceSource.GEONAMES);
        } else {
          sources.push(PlaceSource.ARCGIS_ADDRESSES);
        }
      }
      this.placesService.getPlacesNearLocation(this.keyword, sources, this.getVehiclePosition())
        .pipe(takeUntil(this.subSubject))
        .subscribe(
          (data) => {
            this.searchResult[idx] = data;
            this.selectedItem = {result: this.searchResult[idx][0], idx: idx};
            this.dropDownIndex = -1;
            this.showShowMore(idx);
            this.scrollToBottom();
            this.cd.markForCheck();
          }
        );
    }
  }

  public onKeyUp($event, type: string, idx: number): void {
    switch ($event.key) {
      case 'Enter':
        if (this.selectedItem) {
          this.onChangeValue(this.selectedItem.result, type, idx);
        }
        break;
      case 'Escape':
        this.searchResult = [];
        this.hideShowMore(-1);
        break;
      case 'ArrowDown':
        $event.preventDefault();
        $event.stopPropagation();
        this.handleDown(idx);
        break;
      case 'ArrowUp':
        $event.preventDefault();
        $event.stopPropagation();
        this.handleUp(idx);
        break;
      default:
        this.searchSubject.next({idx: idx, keyword: $event.target.value});
        return;
    }
  }

  private setupPlace(place: PlacesEntry, lat: number, lng: number, type: string, idx: number) {
    let position = {
      lat: MathUtils.roundCoordinates(lat),
      lng: MathUtils.roundCoordinates(lng),
      address: place.name
    };
    let newTask = this.activeForm.controls.destinationPosition.value === null;
    if (type === 'DESTINATION') {
      let searchedDestination = this.activeForm.controls.destination.value;
      this.activeForm.patchValue({
        destination: this.enabledOriginalSearchText ? searchedDestination : position.address,
        destinationPosition: position
      });
      let firstForm = this.forms[0];
      let origin = firstForm.controls.origin.value;
      let originPosition = firstForm.controls.originPosition.value;
      this.reassignOrigins(origin, originPosition, false);
      this.detectCabotageViolation(this.activeForm.controls.type.value);
    } else if (type === 'ORIGIN') {
      let searchedOrigin = this.activeForm.controls.origin.value;
      this.activeForm.patchValue({
        origin: this.enabledOriginalSearchText ? searchedOrigin : position.address,
        originPosition: position
      });
    }
    if (this.activeForm.controls.status.value === 'TODO') {
      this.resetFormStatus(this.activeForm)
    }
    if (newTask && this.activeFormIdx === this.forms.length - 1) {
      this.formStateService.loadForm(this.forms);
    } else {
      this.formStateService.reloadAll({
        shouldRecenter: true,
        formIdx: this.activeFormIdx,
        forms: this.forms
      });
    }
    this.setupByPlaceType(place);
    this.cd.markForCheck();
  }

  private setupByPlaceType(place: PlacesEntry) {
    if (place.source === PlaceSource.POI) {
      this.setupByPoiPlace(place);
    }
  }

  private setupByPoiPlace(place: PlacesEntry) {
    let details = place.details as PoiPlaceDetails;

    if (details.type != null) {
      let poiType = ProTaskManagerUtilsComponent.getPoiType(details.type);
      if (poiType != null) {
        this.activeForm.patchValue({
          type: poiType
        });
      }
    }

    if (details.emails != null) {
      this.patchOption(this.activeForm, details.emails, -7);
    }

    if (details.comment != null) {
      this.activeForm.patchValue({comments: details.comment})
    }
  }

  public onChangeValue(place: PlacesEntry, type: string, idx: number): void {
    if (place) {
      if (place.lat !== 0 && place.lng !== 0) {
        this.setupPlace(place, place.lat, place.lng, type, idx);
      } else {
        this.placesService.placeDetails(place.placeId)
          .pipe(takeUntil(this.subSubject))
          .subscribe((data) => this.setupPlace(place, data.lat, data.lng, type, idx));
      }
      this.searchResult = [];
      this.hideShowMore(type === 'ORIGIN' ? 0 : idx + 1);
    }
  }

  private handleDown(idx: number): void {
    if (!this.searchResult[idx] && this.searchResult[idx].length === 0) {
      this.selectedItem = null;
      return;
    }
    if (this.searchResult[idx].length - 1 > this.dropDownIndex) {
      this.dropDownIndex++;
      this.selectedItem = {result: this.searchResult[idx][this.dropDownIndex], idx: idx};
      let element = <HTMLElement>document.getElementsByClassName(`task-autocomplete__item--${this.dropDownIndex}`)[0];
      element.style.backgroundColor = '#c7c8c9';
      if (this.dropDownIndex > 0) {
        let element = <HTMLElement>document.getElementsByClassName(`task-autocomplete__item--${this.dropDownIndex - 1}`)[0];
        element.style.backgroundColor = 'white'
      }
    }
  }

  private handleUp(idx: number): void {
    if (this.dropDownIndex === -1) {
      this.selectedItem = null;
      return;
    }
    if (this.dropDownIndex > 0) {
      this.dropDownIndex--;
      this.selectedItem = {result: this.searchResult[idx][this.dropDownIndex], idx: idx};
      let element = <HTMLElement>document.getElementsByClassName(`task-autocomplete__item--${this.dropDownIndex}`)[0];
      element.style.backgroundColor = '#c7c8c9';
      if (this.dropDownIndex < this.searchResult[idx].length - 1) {
        let element = <HTMLElement>document.getElementsByClassName(`task-autocomplete__item--${this.dropDownIndex + 1}`)[0];
        element.style.backgroundColor = '';
      }
    } else {
      this.selectedItem = null;
      let element = <HTMLElement>document.getElementsByClassName(`task-autocomplete__item--${this.dropDownIndex}`)[0];
      element.style.backgroundColor = '';
      this.dropDownIndex = -1;
    }
  }

  private getVehiclePosition(): string {
    // TODO implement
    if (this.latestVehicles) {
      let vehicleEntry = this.latestVehicles.filter(it => it.id === this.vehicle)[0];
      return vehicleEntry != null && vehicleEntry.position != null
        ? vehicleEntry.position.latitude + ',' + vehicleEntry.position.longitude
        : '';
    }
    return '';
  }

  public showMore(idx: number, event) {
    event.stopPropagation();
    let sources = [PlaceSource.GOOGLE_ADDRESS];
    this.placesService.getPlacesNearLocation(this.keyword, sources, this.getVehiclePosition())
      .pipe(takeUntil(this.subSubject))
      .subscribe(
        (data) => {
          let message = Number(idx).toString();
          this.searchResult[message] = this.searchResult[message].concat(data);
          this.hideShowMore(idx);
        }
      );
  }

  private hideShowMore(idx: number) {
    if (idx >= 0) {
      let element = document.getElementById(`show-more-${idx}`);
      if (element != null) {
        element.classList.add('hidden');
        this.cd.markForCheck();
      }
    } else {
      let allElements = document.getElementsByClassName('show-more');
      if (allElements.length > 0) {
        for (let i = 0; i < allElements.length; i++) {
          allElements.item(i).classList.add('hidden');
        }
        this.cd.markForCheck();
      }
    }
  }

  private showShowMore(idx: number) {
    setTimeout(() => {
      let element = document.getElementById(`show-more-${idx}`);
      if (element) {
        element.classList.remove('hidden');
      }
      this.cd.markForCheck();
    }, 500);
  }

  /*---------------------------------------------------File-----------------------------------------------------------*/

  public fileChange(event) {
    let fileList: FileList = event.target.files;
    if (fileList.length > 0) {
      let file = fileList[0];
      if (file.size < 10000000) {
        let uuid = this.activeForm.controls.uuid.value;
        this.files.set(uuid, file);
        this.activeForm.patchValue({fileName: file.name});
      } else {
        this.notification.fileLimitExceeded();
      }
    }
  }

  public removeFile() {
    let uuid = this.activeForm.controls.uuid.value;
    this.files.delete(uuid);
    this.activeForm.patchValue({fileName: null});
  }

  /*---------------------------------------------------Additional info------------------------------------------------*/

  public getAdditionalOptions(form: UntypedFormGroup): UntypedFormArray {
    return form.get('additionalInfo') as UntypedFormArray;
  }

  private addAdditionalOptions(formGroup: UntypedFormGroup, form: ProTaskForm) {
    for (let option of this.additionalOptions) {
      this.addToForm(option, formGroup);
    }
    if (form.additionalInfo && form.additionalInfo.length > 0) {
      this.patchOptionValue(formGroup, form.additionalInfo);
    }
  }

  private addToForm(option, form: UntypedFormGroup) {
    if (this.additionalOptions.includes(option)) {
      this.getAdditionalOptions(form).push(
        this.formBuilder.group({
          optionId: [option.id],
          value: this.setAdditionalOptionsValuesAndValidators(option, this.getAdditionalOptions(form)),
          type: [option.type]
        })
      );
    }
  }

  private setAdditionalOptionsValuesAndValidators(option: any, additionalOptions: UntypedFormArray): any[] {
    let validators = this.collectValidators(option, additionalOptions);
    return [option.value, validators];
  }

  private collectValidators(option: any, additionalOptions: UntypedFormArray): ValidatorFn {
    let validators = option.validations;
    let collectedValidators = [];
    if (validators) {
      if (validators.includes('POSITIVE')) {
        collectedValidators.push(Validators.min(1));
      }
      if (validators.includes('INTEGER')) {
        collectedValidators.push(validInteger);
      }
      if (validators.includes('EMAIL')) {
        collectedValidators.push(emailValidator);
      }
      if (validators.includes('FREEZER')) {
        let isLowerValue = option.id === TEMPERATURE_LOW_ID;
        let optionToCompareId = isLowerValue ? TEMPERATURE_HIGH_ID : TEMPERATURE_LOW_ID
        collectedValidators.push(temperatureRange(additionalOptions, optionToCompareId, isLowerValue));
      }
      if (validators.includes('SECOND_FREEZER')) {
        let isLowerValue = option.id === SECOND_TEMPERATURE_LOW_ID;
        let optionToCompareId = isLowerValue ? SECOND_TEMPERATURE_HIGH_ID : SECOND_TEMPERATURE_LOW_ID
        collectedValidators.push(temperatureRange(additionalOptions, optionToCompareId, isLowerValue));
      }
    }
    return Validators.compose(collectedValidators);
  }

  private patchOptionValue(formGroup: UntypedFormGroup, additionalInfo: AdditionalInfoForm[]) {
    let additionalOptions = this.getAdditionalOptions(formGroup);
    for (let info of additionalInfo) {
      let index = this.getFormOptionIndex(info.optionId, formGroup);
      if (index !== -1) {
        let isNumberType = this.additionalOptions[this.findAdditionalOptionIndex(info.optionId)].type === 'LONG';
        additionalOptions.at(index).patchValue({
          value: isNumberType && info.value !== null
            ? +info.value
            : info.value
        });
      } else {
        let optionForForm = {
          id: info.optionId,
          value: info.value,
          type: info.type
        };
        this.addToForm(optionForForm, formGroup);
      }
    }
  }

  private getFormOptionIndex(id: number, formGroup: UntypedFormGroup) {
    return this.getAdditionalOptions(formGroup).getRawValue().findIndex(value => value.optionId === id);
  }

  public getPlaceHolder(id: number): string {
    let currentLang = this.translate.currentLang;
    let index = this.findAdditionalOptionIndex(id);
    return this.additionalOptions[index][currentLang + 'Name'];
  }

  public getIcon(option: AbstractControl): string {
    return this.additionalOptions[this.findAdditionalOptionIndex(option.value.optionId)].icon;
  }

  public getEnumTypes(type: string): string[] {
    switch (type) {
      case 'ENUM_FREEZER_MODE':
        return EnumValues.getNames(FreezerModeType);
      default:
        return [];
    }
  }

  private findAdditionalOptionIndex(id: number) {
    return this.additionalOptions.findIndex(option => option.id === id);
  }

  private moveAdditionalInfoValue(additionalInfoId: number, from: UntypedFormGroup, to: UntypedFormGroup, copy: boolean = false): void {
    let fromIndex = this.getFormOptionIndex(additionalInfoId, from);
    let intoIndex = this.getFormOptionIndex(additionalInfoId, to);
    if (fromIndex !== -1 && intoIndex !== -1) {
      let fromOptions = this.getAdditionalOptions(from);
      let intoOptions = this.getAdditionalOptions(to);
      let value = fromOptions.value[fromIndex].value;
      intoOptions.at(intoIndex).patchValue({value: value});
      if (!copy) {
        fromOptions.at(fromIndex).patchValue({value: null});
      }
    }
  }

  /*------------------------------------------------------Fuel--------------------------------------------------------*/

  public checkAndTriggerFuelChange(option: AdditionalInfoForm): void {
    let optionIndex = this.additionalOptions[this.findAdditionalOptionIndex(option.optionId)];
    if (this.activeForm.valid && optionIndex.option === 'FUEL_AMOUNT' || optionIndex.option === 'ADBLUE_AMOUNT') {
      this.formStateService.triggerReloadFuel(this.forms);
    }
    if (this.keepSameTemperature && this.activeForm.valid
        && this.activeForm.value.type === 'LOADING'
        && (option.optionId === FREEZER_TEMPERATURE_ID
        || option.optionId === FREEZER_SECOND_COMPARTMENT_TEMPERATURE_ID
        || option.optionId === FREEZER_MODE_ID)) {

      this.updateTemperatures(this.activeForm);
    }
    this.determineFuelWarning();
  }

  private updateTemperatures(targetForm: UntypedFormGroup): void {
    const loadingForms = this.forms.filter(form => form.value.type === 'LOADING'
      && form.value.idx >= targetForm.value.idx);
      const nextLoadingForm = this.findLoadingFormBreakpoint(loadingForms, true);
      let formsToUpdate = this.forms.filter(form =>
        nextLoadingForm.value.idx === targetForm.value.idx
          ? form.value.idx > targetForm.value.idx
          : form.value.idx > targetForm.value.idx && form.value.idx < nextLoadingForm.value.idx
      )
      formsToUpdate.forEach(formToUpdate => this.moveTemperatureData(targetForm, formToUpdate));
  }

  private getFuelConsumptionAndCheckWarning() {
    this.managerService.fetchFuelInfo(this.data.vehicle.id)
      .pipe(takeUntil(this.subSubject))
      .subscribe(
        (data) => {
          this.fuelUsageFor100km = data?.fuelUsage ? Number(data.fuelUsage) : DEFAULT_TRUCK_FUEL_USAGE;
          this.fuelType = data?.fuelType ?? null;
          this.determineFuelWarning();
          this.currentRouteCost = ProTaskManagerUtilsComponent.calculateRouteCost(
            this.averageFuelPrice,
            this.averageTruckRentPrice,
            this.fuelUsageFor100km,
            this.data.currentTotals.duration,
            this.data.currentTotals.tolls.totalCost,
            this.data.currentTotals.distance,
            this.data.currentTasks.map(it => it.markedRoadsTolls).reduce((a, b) => a + b, 0)
          );
          this.data.currentTasks.forEach(task => {
            this.eachTaskRouteCost.push(ProTaskManagerUtilsComponent.calculateRouteCost(
              this.averageFuelPrice,
              this.averageTruckRentPrice,
              this.fuelUsageFor100km,
              task.duration,
              task.tolls.totalCost,
              task.distance,
              task.markedRoadsTolls
            ))
          });
          this.recalculatePlanningRouteInfo();
          this.totalCO2Emission = this.calculateCO2Emission(this.data.currentTotals.distance);
          this.activeRouteCO2Emission = this.calculateCO2Emission(this.activeForm.controls.distance.value);
          this.cd.detectChanges();
        }
      );
  }

  private determineFuelWarning(): void {
    if (this.hasNoFuelData()) {
      this.fuelWarning = false;
    } else {
      const taskFuelData = calculateTasksFuelData(
        this.forms,
        this.data.vehicle.fuel,
        this.fuelUsageFor100km,
        this.data.vehicle.fuelTankCapacity,
        0
      );
      this.fuelWarning = checkForFuelWarning(
        taskFuelData,
        this.data.vehicle.fuelTankCapacity,
        this.FUEL_WARNING_THRESHOLD
      );
    }
  }

  private hasNoFuelData() {
    return this.data.vehicle.fuel === 0
      && this.data.vehicle.fuelTankCapacity === 0;
  }

  /*------------------------------------------------Fuel Tank Button--------------------------------------------------*/

  public addFullTank(optionId: number): void {
    this.setFuelOptionValue(optionId, FULL_TANK);
    this.detectFuelOptionValue();
  }

  public deleteTank(optionId: number): void {
    this.setFuelOptionValue(optionId, null);
    this.detectFuelOptionValue();
  }

  private setFuelOptionValue(optionId: number, fuelValue: string): void {
    let additionalOptions = this.getAdditionalOptions(this.activeForm).value
      .filter(it => it.optionId !== optionId)
    let newFuelOptionValue = new AdditionalInfoForm(fuelValue, optionId, 'LONG')
    this.patchOptionValue(this.activeForm, [...additionalOptions, newFuelOptionValue]);
    if (optionId === FUEL_ADDITIONAL_ID) {
      this.checkAndTriggerFuelChange(newFuelOptionValue)
    }
  }

  private detectFuelOptionValue(): void {
    let fuelInput = (<HTMLInputElement>document.getElementById('-5-TANK'));
    let adBlueInput = (<HTMLInputElement>document.getElementById('-6-TANK'));
    if (fuelInput) {
      fuelInput.hidden = fuelInput.value === FULL_TANK;
    }
    if (adBlueInput) {
      adBlueInput.hidden = adBlueInput.value === FULL_TANK;
    }
  }

  /*---------------------------------------------------Parameters-----------------------------------------------------*/

  public activateRouteParams(): void {
    this.routeParamsActive = true;
    this.fuellingActive = false;
    this.parkingsActive = false;
    this.templatesActive = false;
    this.formsActive = false;
    this.repairOrdersActive = false;
    this.formStateService.triggerParamsSwitch('ROUTE');
  }

  public activateFuelling(): void {
    this.routeParamsActive = false;
    this.fuellingActive = true;
    this.parkingsActive = false;
    this.templatesActive = false;
    this.formsActive = false;
    this.repairOrdersActive = false;
    this.formStateService.triggerParamsSwitch('FUELING');
  }

  public activateParkings(): void {
    this.routeParamsActive = false;
    this.fuellingActive = false;
    this.parkingsActive = true;
    this.templatesActive = false;
    this.formsActive = false;
    this.repairOrdersActive = false;
    this.formStateService.triggerParamsSwitch('PARKING');
  }

  public activateTemplates(): void {
    this.routeParamsActive = false;
    this.fuellingActive = false;
    this.parkingsActive = false;
    this.templatesActive = true;
    this.formsActive = false;
    this.repairOrdersActive = false;
    this.formStateService.triggerParamsSwitch('TEMPLATES');
  }

  public activateForms(): void {
    this.routeParamsActive = false;
    this.fuellingActive = false;
    this.parkingsActive = false;
    this.templatesActive = false;
    this.formsActive = true;
    this.repairOrdersActive = false;
    this.formStateService.triggerParamsSwitch('FORMS');
  }

  public activateRepairOrders(): void {
    this.routeParamsActive = false;
    this.fuellingActive = false;
    this.parkingsActive = false;
    this.templatesActive = false;
    this.formsActive = false;
    this.repairOrdersActive = true;
    this.formStateService.triggerParamsSwitch('REPAIR_ORDERS');
  }

  public onServicePlanningState(state: ServicePlanningTabState): void {
    this.servicePlanningState = state;
    this.cd.markForCheck();
  }

  /*---------------------------------------------------Form-----------------------------------------------------------*/

  public newForm(): UntypedFormGroup {
    let vehicle = this.latestVehicles.filter(it => it.id === +this.vehicle)[0];
    let formGroup = this.formBuilder.group({
      id: [null],
      vehicle: [this.vehicle],
      idx: [this.forms.length],
      uuid: [UUID()],
      origin: [vehicle.position != null ? vehicle.plateNumber : null, Validators.required],
      destination: [null, Validators.required],
      originPosition: [vehicle.position != null
        ? {
          lat: vehicle.position.latitude,
          lng: vehicle.position.longitude
        }
        : null],
      destinationPosition: [null],
      waypoints: [[]],
      distance: [null],
      duration: [null],
      durationItself: [null],
      timeFrom: [null],
      timeTill: [null],
      zoneId: [null],
      orderNumber: [null],
      truckRoute: [null],
      legs: [null],
      countries: [null],
      roads: [],
      type: [null, Validators.required],
      status: ['UNCONFIRMED'],
      tolls: [null],
      tolledTunnels: [null],
      markedRoadsTolls: [null],
      comments: [null],
      routeInfo: [null],
      orderId: [null],
      additionalInfo: this.formBuilder.array([]),
      fileName: [null],
      sendMessage: [AuthStorage.getTasksConfigs().sendDriverMessage],
      emptyDistance: [false],
      weight: [null],
      axleWeight: [null],
      height: [null],
      width: [null],
      length: [null],
      strategy: [null],
      vehicleType: [null],
      avoids: [[]],
      hazardous: [false],
      hazardousType: ['A'],
      emissionType: [null],
      externalPoiId: [null],
      contactlessType: [null],
      parkingId: [null],
      parkingType: [null],
      bookingId: [null],
      poiId: [null],
      planningServiceId: [null],
      alternatives: [null],
      traffic: [TaskUtils.getCookiesTraffic(this.cookieService)],
      incidents: [null],
      badMarkedRoads: [null],
      conditionalRestrictions: [null],
      excludedCountries: [TaskUtils.getCookiesExcludedCountries(this.cookieService)],
      taskForms: [[]],
      hideTaskUpdatedNotification: [false],
      preferableRouteApplied: [false],
      inProgressSince: [null]
    },
    {
      validators: [
        validateFieldTillLaterThanFrom('timeFrom', 'timeTill'),
        requiredIfAnyFilled('zoneId', ['timeFrom', 'timeTill'])
      ]
    });
    for (let option of this.additionalOptions) {
      this.addToForm(option, formGroup);
    }
    return formGroup;
  }

  public emptyForm(): UntypedFormGroup {
    let lastForm = this.forms[this.forms.length - 1];
    let formGroup = this.formBuilder.group({
      id: [null],
      vehicle: [this.vehicle],
      idx: [this.forms.length],
      uuid: [UUID()],
      origin: [lastForm.controls.destination.value, Validators.required],
      destination: [null, Validators.required],
      originPosition: [lastForm.controls.destinationPosition.value],
      destinationPosition: [null],
      waypoints: [[]],
      distance: [null],
      duration: [null],
      durationItself: [null],
      timeFrom: [null],
      timeTill: [null],
      zoneId: [null],
      orderNumber: [null],
      truckRoute: [null],
      legs: [null],
      countries: [null],
      roads: [],
      type: [null, Validators.required],
      status: ['UNCONFIRMED'],
      tolls: [null],
      tolledTunnels: [null],
      markedRoadsTolls: [null],
      comments: [null],
      routeInfo: [null],
      orderId: [null],
      additionalInfo: this.formBuilder.array([]),
      fileName: [null],
      sendMessage: [AuthStorage.getTasksConfigs().sendDriverMessage],
      emptyDistance: [false],
      weight: [null],
      axleWeight: [null],
      height: [null],
      width: [null],
      length: [null],
      strategy: [TruckConstants.DEFAULT_STRATEGY],
      vehicleType: [null],
      avoids: [[]],
      hazardous: [null],
      hazardousType: ['A'],
      emissionType: [TruckConstants.DEFAULT_EMISSION_TYPE],
      externalPoiId: [null],
      contactlessType: [null],
      parkingId: [null],
      parkingType: [null],
      bookingId: [null],
      poiId: [null],
      planningServiceId: [null],
      alternatives: [lastForm.controls.alternatives.value],
      traffic: [TaskUtils.getCookiesTraffic(this.cookieService)],
      incidents: [lastForm.controls.incidents.value],
      badMarkedRoads: [lastForm.controls.badMarkedRoads.value],
      conditionalRestrictions: [lastForm.controls.conditionalRestrictions.value],
      excludedCountries: [TaskUtils.getCookiesExcludedCountries(this.cookieService)],
      taskForms: [[]],
      hideTaskUpdatedNotification: [false],
      preferableRouteApplied: [false],
      inProgressSince: [null]
    },
    {
      validators: [
        validateFieldTillLaterThanFrom('timeFrom', 'timeTill'),
        requiredIfAnyFilled('zoneId', ['timeFrom', 'timeTill'])
      ]
    });
    for (let option of this.additionalOptions) {
      this.addToForm(option, formGroup);
    }
    return formGroup;
  }

  public emptyFromTemplate(template: TemplateDetailsEntry): UntypedFormGroup {
    let lastForm = this.forms[this.forms.length - 1];
    let formGroup = this.formBuilder.group({
      id: [null],
      vehicle: [this.vehicle],
      idx: [this.forms.length],
      uuid: [UUID()],
      origin: [lastForm.controls.destination.value, Validators.required],
      destination: [template.destination.address != null && template.destination.address.length > 0
        ? template.destination.address
        : template.destination.lat.toString() + ', ' + template.destination.lng.toString(),
        Validators.required
      ],
      originPosition: [lastForm.controls.destinationPosition.value],
      destinationPosition: [template.destination],
      waypoints: [template.waypoints],
      distance: [null],
      duration: [null],
      timeFrom: [null],
      timeTill: [null],
      zoneId: [null],
      orderNumber: [null],
      truckRoute: [null],
      legs: [null],
      countries: [null],
      roads: [],
      type: [template.type, Validators.required],
      status: ['UNCONFIRMED'],
      tolls: [null],
      tolledTunnels: [null],
      markedRoadsTolls: [null],
      comments: [template.comment],
      routeInfo: [null],
      orderId: [null],
      additionalInfo: this.formBuilder.array([]),
      fileName: [null],
      sendMessage: [lastForm.controls.sendMessage.value],
      emptyDistance: [false],
      weight: [template.weight],
      axleWeight: [template.axleWeight],
      height: [template.height],
      width: [template.width],
      length: [template.length],
      strategy: [template.strategy],
      vehicleType: [template.vehicleType],
      avoids: [template.avoids],
      hazardous: [null],
      hazardousType: ['A'],
      emissionType: [TruckConstants.DEFAULT_EMISSION_TYPE],
      externalPoiId: [null],
      contactlessType: [null],
      parkingId: [null],
      parkingType: [null],
      bookingId: [null],
      poiId: [null],
      planningServiceId: [null],
      alternatives: [lastForm.controls.alternatives.value],
      traffic: [template.traffic],
      incidents: [lastForm.controls.incidents.value],
      badMarkedRoads: [lastForm.controls.badMarkedRoads.value],
      conditionalRestrictions: [lastForm.controls.conditionalRestrictions.value],
      excludedCountries: [[]],
      taskForms: [[]],
      hideTaskUpdatedNotification: [false],
      preferableRouteApplied: [false],
      inProgressSince: [null]
    },
    {
      validators: [
        validateFieldTillLaterThanFrom('timeFrom', 'timeTill'),
        requiredIfAnyFilled('zoneId', ['timeFrom', 'timeTill'])
      ]
    });
    for (let option of this.additionalOptions) {
      this.addToForm(option, formGroup);
    }
    return formGroup;
  }

  private insertNewForm(form: UntypedFormGroup): UntypedFormGroup {
    let vehicle = this.latestVehicles.filter(it => it.id === +this.vehicle)[0];
    let formGroup = this.formBuilder.group({
      id: [null],
      vehicle: [this.vehicle],
      idx: [this.forms.length],
      uuid: [UUID()],
      origin: [vehicle.position != null ? vehicle.plateNumber : null, Validators.required],
      destination: [null, Validators.required],
      originPosition: [vehicle.position != null
        ? {
          lat: vehicle.position.latitude,
          lng: vehicle.position.longitude
        }
        : null],
      destinationPosition: [null],
      waypoints: [[]],
      distance: [null],
      duration: [null],
      timeFrom: [null],
      timeTill: [null],
      zoneId: [null],
      orderNumber: [null],
      truckRoute: [null],
      legs: [null],
      countries: [null],
      roads: [],
      type: [null, Validators.required],
      status: ['UNCONFIRMED'],
      tolls: [null],
      tolledTunnels: [null],
      markedRoadsTolls: [null],
      comments: [null],
      routeInfo: [null],
      orderId: [null],
      additionalInfo: this.formBuilder.array([]),
      fileName: [null],
      sendMessage: [form.controls.sendMessage.value],
      emptyDistance: [false],
      weight: [null],
      axleWeight: [null],
      height: [null],
      width: [null],
      length: [null],
      strategy: [TruckConstants.DEFAULT_STRATEGY],
      vehicleType: [null],
      avoids: [[]],
      hazardous: [null],
      hazardousType: ['A'],
      emissionType: [TruckConstants.DEFAULT_EMISSION_TYPE],
      externalPoiId: [null],
      contactlessType: [null],
      parkingId: [null],
      parkingType: [null],
      bookingId: [null],
      poiId: [null],
      planningServiceId: [null],
      alternatives: [form.controls.alternatives.value],
      traffic: [TaskUtils.getCookiesTraffic(this.cookieService)],
      incidents: [form.controls.incidents.value],
      badMarkedRoads: [form.controls.badMarkedRoads.value],
      conditionalRestrictions: [form.controls.conditionalRestrictions.value],
      excludedCountries: [TaskUtils.getCookiesExcludedCountries(this.cookieService)],
      taskForms: [[]],
      hideTaskUpdatedNotification: [false],
      preferableRouteApplied: [false],
      inProgressSince: [null]
    },
    {
      validators: [
        validateFieldTillLaterThanFrom('timeFrom', 'timeTill'),
        requiredIfAnyFilled('zoneId', ['timeFrom', 'timeTill'])
      ]
    });
    for (let option of this.additionalOptions) {
      this.addToForm(option, formGroup);
    }
    return formGroup;
  }

  public toForm(form: ProTaskForm): UntypedFormGroup {
    if (this.executingDistance == null && this.executing(form.status)) {
      this.executingDistance = form.distanceRemaining != null && form.distance >= form.distanceRemaining
        ? form.distanceRemaining
        : null;
    }
    let formGroup = this.formBuilder.group({
      id: [form.id],
      vehicle: [this.vehicle],
      idx: [form.idx],
      uuid: [form.uuid],
      origin: [form.origin, Validators.required],
      destination: [form.destination, Validators.required],
      originPosition: [form.originPosition],
      destinationPosition: [form.destinationPosition],
      waypoints: [form.waypoints],
      distance: [form.distance],
      duration: [form.duration],
      durationItself: [form.durationItself, maxWeekDurationInMinutesValidator],
      timeFrom: [form.timeFrom],
      timeTill: [form.timeTill],
      zoneId: [form.zoneId],
      orderNumber: [form.orderNumber],
      truckRoute: [form.truckRoute],
      legs: [form.legs],
      countries: [form.countries],
      roads: [],
      type: [form.type, Validators.required],
      status: [form.status],
      tolls: [form.tolls],
      tolledTunnels: [form.tolledTunnels],
      markedRoadsTolls: [form.markedRoadsTolls],
      comments: [form.comments],
      routeInfo: [form.routeInfo],
      orderId: [form.orderId],
      additionalInfo: this.formBuilder.array([]),
      fileName: [form.fileName],
      sendMessage: [form.sendMessage],
      emptyDistance: [form.emptyDistance],
      weight: [form.weight],
      axleWeight: [form.axleWeight],
      height: [form.height],
      width: [form.width],
      length: [form.length],
      strategy: [form.strategy],
      vehicleType: [form.vehicleType],
      avoids: [form.avoids],
      hazardous: [form.hazardous],
      hazardousType: [form.hazardousType],
      emissionType: [form.emissionType],
      externalPoiId: [form.externalPoiId],
      contactlessType: [form.contactlessType],
      parkingId: [form.parkingId],
      parkingType: [form.parkingType],
      bookingId: [form.bookingId],
      poiId: [form.poiId],
      planningServiceId: [form.planningServiceId],
      distanceRemaining: [this.executing(form.status) ? this.executingDistance : null],
      durationRemaining: [form.durationRemaining],
      alternatives: [null],
      traffic: [form.traffic],
      incidents: [null],
      badMarkedRoads: [null],
      conditionalRestrictions: [null],
      excludedCountries: [form.excludedCountries],
      taskForms: [form.taskForms],
      hideTaskUpdatedNotification: [form.hideTaskUpdatedNotification],
      preferableRouteApplied: [form.preferableRouteApplied],
      aiGenerated: [this.suggestionTaskUuids.includes(form.uuid)],
      inProgressSince: [form.inProgressSince],
      fuelStationInformation: [form.fuelStationInformation],
      fuelStationPrice: [form.fuelStationPrice]
    },
    {
      validators: [
        validateFieldTillLaterThanFrom('timeFrom', 'timeTill'),
        requiredIfAnyFilled('zoneId', ['timeFrom', 'timeTill'])
      ]
    });
    this.addAdditionalOptions(formGroup, form);
    return formGroup;
  }

  public executing(status: string): boolean {
    return status === 'EXECUTING'
      || status === 'ARRIVED'
      || status === 'WAITING'
      || status === 'IN_PROGRESS'
      || status === 'FINISHING';
  }

  private latLngToFixed(data: ProTaskForm[]) {
    data.map(it => {
      it.originPosition.lat = +it.originPosition.lat.toFixed(6);
      it.originPosition.lng = +it.originPosition.lng.toFixed(6);
      it.destinationPosition.lat = +it.destinationPosition.lat.toFixed(6);
      it.destinationPosition.lng = +it.destinationPosition.lng.toFixed(6)
    })
  }

  /*---------------------------------------------------Event handler--------------------------------------------------*/

  public handlePasteEvent(keyword: string, input: number, event: any): void {
    if (keyword != null && keyword !== '') {
      let latLng = keyword.split(/[, ]+/);
      let numberRegExp = /^[-+]?\d+\.\d+$/;
      if ((numberRegExp.test(latLng[0]) && numberRegExp.test(latLng[1])) || keyword.match(POST_CODE_REGEX)) {
        this.searchSubject.next({idx: input, keyword: keyword.split(/[, ]+/)});
      } else {
        let source = [
          PlaceSource.GOOGLE_PLACES_PASTE,
          PlaceSource.POI,
          PlaceSource.GOOGLE_ADDRESS
        ];
        this.placesService.getPlacesNearLocation(keyword, source, this.getVehiclePosition())
          .pipe(takeUntil(this.subSubject))
          .subscribe(
            (data) => {
              this.searchResult[input] = data;
              this.selectedItem = {result: this.searchResult[input][0], idx: input};
              this.dropDownIndex = -1;
              this.cd.markForCheck();
            });
        this.hideShowMore(input);
        event.stopImmediatePropagation();
      }
    }
  }

  /*---------------------------------------Route from old task planner -----------------------------------------------*/

  private processOldTaskRequest(oldTask: any, edit: any, idx: any, formType: any) {
    this.oldTaskInfo = JSON.parse(oldTask);
    this.notEditingOldTask = edit === 'true';
    this.oldTaskIdx = +JSON.parse(idx);
    this.oldTaskFormType = formType;
    this.normalizeUrl();
    setTimeout(() => this.patchOldTaskValues(), 500)
  }

  private normalizeUrl() {
    this.location.replaceState(`/tasks/${this.vehicle}/manager/pro`);
    this.router.navigate([], {
      queryParams: {
        'oldTask': null,
        'edit': null,
        'idx': null,
        'formType': null
      },
      queryParamsHandling: 'merge'
    });
  }

  private patchOldTaskValues() {
    if (this.oldTaskIdx !== -1) {
      if (this.notEditingOldTask) {
        let newForm;
        if (this.oldTaskInfo.destination != null && this.forms[0].controls.destinationPosition.value != null) {
          newForm = this.oldTaskIdx === 0 ? this.insertNewForm(this.forms[0]) : this.emptyForm();
          this.addDestination(this.oldTaskInfo.destination, newForm);
          this.forms.splice(this.oldTaskIdx, 0, newForm);
        } else if (this.oldTaskInfo.destination != null && this.forms[0].controls.destinationPosition.value == null) {
          newForm = this.forms[0];
          let lat = this.oldTaskInfo.destination.lat;
          let lng = this.oldTaskInfo.destination.lng;
          newForm.patchValue({
            destinationPosition: {
              lat: lat,
              lng: lng,
            },
            destination: this.oldTaskInfo.searchText
          });
        } else {
          newForm = this.emptyForm();
          this.forms.splice(this.oldTaskIdx, 0, newForm);
        }
        this.patchValuesForForm(newForm);
        this.forms.forEach(it => it.patchValue({idx: this.forms.indexOf(it)}));
        this.activeForm = newForm;
        this.activeFormIdx = this.forms[this.oldTaskIdx].controls.idx.value;
        let firstForm = this.forms[0];
        let origin = firstForm.controls.origin.value;
        let originPosition = firstForm.controls.originPosition.value;
        this.reassignOrigins(origin, originPosition, false);
        this.formStateService.reloadAll({
          shouldRecenter: false,
          formIdx: null,
          forms: this.forms
        });
      } else {
        this.patchValuesForForm(this.forms[this.oldTaskIdx]);
        let form = this.forms[this.oldTaskIdx];
        let originChanged = TaskUtils
          .pointsAreDifferent(form.controls.originPosition.value, this.oldTaskInfo.origin);
        let destinationChanged = TaskUtils
          .pointsAreDifferent(form.controls.destinationPosition.value, this.oldTaskInfo.destination);
        if (originChanged) {
          this.addOrigin(this.oldTaskInfo.origin, form);
        }
        if (destinationChanged) {
          this.addDestination(this.oldTaskInfo.destination, form);
        }
        let firstForm = this.forms[0];
        let origin = firstForm.controls.origin.value;
        let originPosition = firstForm.controls.originPosition.value;
        this.reassignOrigins(origin, originPosition, false);
        this.formStateService.reloadAll({
          shouldRecenter: false,
          formIdx: null,
          forms: this.forms
        });
        let newForm = this.emptyForm();
        let newFormIdx = this.oldTaskIdx + 1;
        this.forms.splice(newFormIdx, 0, newForm);
        this.forms.forEach(it => it.patchValue({idx: this.forms.indexOf(it)}));
        this.activeForm = newForm;
        this.activeFormIdx = this.forms[newFormIdx].controls.idx.value;
      }
      this.formStateService.triggerActiveForm(this.activeForm);
      this.cd.detectChanges();
    }
  }

  private patchValuesForForm(form: UntypedFormGroup) {
    form.patchValue({
      waypoints: this.oldTaskInfo.waypoints != null
        ? TaskUtils.toMapPositions(this.oldTaskInfo.waypoints)
        : form.controls.waypoints.value,
      type: this.oldTaskFormType !== ''
        ? this.oldTaskFormType
        : form.controls.type.value
    });
  }

  /*------------------------------------------------Template----------------------------------------------------------*/

  public appendFromTemplate(detailsEntries: TemplateDetailsEntry[]): void {
    this.activeForm.patchValue(toFullForm(detailsEntries[0]));
    for (let i = 1; i < detailsEntries.length; i++) {
      const templateForm = this.emptyFromTemplate(detailsEntries[i]);
      this.addNewTask(templateForm);
    }
    this.formStateService.reloadAll({
      shouldRecenter: true,
      formIdx: null,
      forms: this.forms
    });
    this.formStateService.triggerActiveForm(this.activeForm);

  }

  /*-------------------------------------------------Other------------------------------------------------------------*/

  public getAddressText(task: CurrentTaskEntry): string {
    return ProTaskManagerUtilsComponent.getAddressText(task.dispatcherAddress, task.searchText, this.enabledAddresses);
  }

  public toggleLastTrip() {
    const lastTrip = this.data.doneTask;
    const vehicle = this.latestVehicles.filter(it => it.id === +this.vehicle)[0];
    let form = this.forms[0];
    if (lastTrip != null) {
      const lastTripAddress = lastTrip.destination.address != null
        ? lastTrip.destination.address
        : lastTrip.destination.lat + ',' + lastTrip.destination.lng;
      const vehicleAddress = vehicle.position != null
        ? vehicle.plateNumber
        : null;
      const vehiclePosition = vehicle.position != null
        ? {lat: vehicle.position.latitude, lng: vehicle.position.longitude}
        : null;
      const lastTripPosition = {lat: lastTrip.destination.lat, lng: lastTrip.destination.lng};
      this.useLastTripCoords = !this.useLastTripCoords;
      form.patchValue({
        origin: this.useLastTripCoords
          ? lastTripAddress
          : vehicleAddress,
        originPosition: this.useLastTripCoords
          ? lastTripPosition
          : vehiclePosition
      });
      this.cd.markForCheck();
      if (form.controls.destinationPosition.value != null) {
        this.formStateService.reloadForm(form);
      }
    } else {
      this.notification.info('proTasks.form.no-last-trip');
    }
  }

  private recalculatePlanningRouteInfo() {
    this.clearEtas();
    this.planningRouteCost = ProTaskManagerUtilsComponent.calculateRouteCost(
      this.averageFuelPrice,
      this.averageTruckRentPrice,
      this.fuelUsageFor100km,
      this.activeForm.controls.duration.value,
      this.activeForm.controls.tolls.value != null ? this.activeForm.controls.tolls.value.totalCost : null,
      this.activeForm.controls.distance.value,
      this.activeForm.controls.markedRoadsTolls.value
    );
    this.planningTotalDistance = ProTaskManagerUtilsComponent.calculatePlanningDistance(this.forms);
    this.resolveUnsavedRouteInfo();
  }

  private resolveUnsavedRouteInfo(): void {
    this.unsavedFormsCountryTolls = [];
    this.unsavedForms = this.forms.filter(it => this.data.forms
      .find(form => form.idx === it.value.idx && form.id === it.value.id) == null);
    if (this.unsavedForms.length > 0) {
      this.unsavedFormsTotalDistance = ProTaskManagerUtilsComponent.calculatePlanningDistance(this.unsavedForms);
      this.unsavedFormsDuration = this.unsavedForms
        .map(form => form.value.duration)
        .reduce((a, b) => a + b);
      this.unsavedFormsTolls = this.unsavedForms
        .map(form => form.value.tolls?.totalCost != null ? +form.value.tolls.totalCost : 0)
        .reduce((a, b) => a + b);
      this.unsavedForms.forEach(form => {
        if (form.value.tolls?.countryTolls != null) {
          let countryTolls = form.value.tolls.countryTolls;
          this.resolveCountryTolls(countryTolls);
        }
      });
      this.unsavedFormsCO2Emission = this.calculateCO2Emission(this.unsavedFormsTotalDistance);
      this.unsavedTasksRouteCost = ProTaskManagerUtilsComponent.calculateRouteCost(
        this.averageFuelPrice,
        this.averageTruckRentPrice,
        this.fuelUsageFor100km,
        this.unsavedFormsDuration,
        this.unsavedFormsTolls,
        this.unsavedFormsTotalDistance,
        null
      );
    }
  }

  private resolveCountryTolls(countryTolls: TollCountryEntry[]): void {
      countryTolls.forEach(it => {
        let idx = this.unsavedFormsCountryTolls.findIndex(entry => entry.country == it.country);
        if (idx > -1) {
          let amount = it.amountInTargetCurrency;
          this.unsavedFormsCountryTolls[idx].amountInTargetCurrency += amount;
        } else {
          this.unsavedFormsCountryTolls.push({country: it.country, amountInTargetCurrency: it.amountInTargetCurrency});
        }
      });
  }

  private getTaskPlannerConfigs() {
    let tasksConfigs = AuthStorage.getTasksConfigs();
    this.enabledAddresses = tasksConfigs.enabledAddresses;
    this.enabledDefaultWaypoints = tasksConfigs.enabledDefaultWaypoints != null
      ? tasksConfigs.enabledDefaultWaypoints
      : false;
    this.enabledOriginalSearchText = tasksConfigs.enabledOriginalSearchText != null
      ? tasksConfigs.enabledOriginalSearchText
      : false;
  }

  private getIsAutomaticReplanning(): void {
    let autoReplannableVehicles = AuthStorage.getAutoReplanningVehicles();
    let entry = autoReplannableVehicles.get(+this.vehicle);
    if (entry === undefined) {
      this.persistAutoReplannigForVehicle(autoReplannableVehicles, +this.vehicle);
    } else {
      this.isAutomaticReplanning = entry;
    }
  }

  private persistAutoReplannigForVehicle(vehicles: Map<number, boolean>, id: number): void {
    this.fuellingReplanningConfigsService.isAutomaticReplanning(id)
      .pipe(takeUntil(this.subSubject))
      .subscribe({
        next: (data) => {
          vehicles.set(id, data);
          AuthStorage.saveAutoReplanningVehicles(vehicles);
          this.isAutomaticReplanning = data;
        },
        error: () => {
          this.isAutomaticReplanning = false;
        }
      });
  }

  private scrollToBottom() {
    const planningDiv = document.getElementById('planning');
    if (planningDiv != null) {
      setTimeout(() => {
        jQuery(planningDiv).animate({scrollTop: planningDiv.scrollHeight}, 'slow');
      }, 250);
    }
  }

  public calculateEtas(): void {
    let forms = this.forms.filter(it => it.value.destinationPosition != null);
    if (forms.length > 0) {
      this.managerService.getETAQueue(this.data.vehicle.id, this.etaRequest(forms))
        .pipe(takeUntil(this.subSubject))
        .subscribe({
          next: (etas) => {
            this.etas = new Map(forms.map((it, index) => [it.value.uuid, etas[index]]));
            this.publishServiceEtas();
            this.cd.markForCheck();
          },
          error: () => this.notification.loadingError()
        });
    }
  }

  public etaOf(form: UntypedFormGroup): string {
    return this.etas.get(form.value.uuid);
  }

  public isLate(form: UntypedFormGroup): boolean {
    let eta = this.etaOf(form);
    return eta != null && form.value.timeTill != null && form.value.timeTill !== '' && eta > form.value.timeTill;
  }

  public isServiceInsert(form: UntypedFormGroup): boolean {
    return form.value.type === 'SERVICE' && form.value.poiId != null;
  }

  public resetServiceInsert(): void {
    if (this.serviceInsertSnapshot != null) {
      this.forms = this.serviceInsertSnapshot.map(it => this.toForm(it));
      this.serviceInsertSnapshot = null;
      this.clearEtas();
      let firstForm = this.forms[0];
      this.activeForm = firstForm;
      this.activeFormIdx = firstForm.controls.idx.value;
      this.reassignOrigins(firstForm.controls.origin.value, firstForm.controls.originPosition.value, true);
      this.formStateService.reloadAll({
        shouldRecenter: false,
        formIdx: null,
        forms: this.forms
      });
      this.formStateService.triggerActiveForm(this.activeForm);
      this.formStateService.triggerServiceInserted(null);
      this.cd.markForCheck();
    }
  }

  private snapshotBeforeServiceInsert(data: PoiInsertTask): void {
    if (data.type === 'SERVICE' && data.poiId != null) {
      if (this.serviceInsertSnapshot == null) {
        this.serviceInsertSnapshot = JSON.parse(JSON.stringify(this.forms.map(it => it.getRawValue())));
      }
      this.formStateService.triggerServiceInserted(data.poiId);
    }
  }

  public clearEtas(): void {
    if (this.etas.size > 0) {
      this.etas = new Map<string, string>();
      this.publishServiceEtas();
    }
  }

  private publishServiceEtas(): void {
    this.formStateService.triggerServiceEtas(new Map(this.forms
      .filter(it => this.isServiceInsert(it) && this.etaOf(it) != null)
      .map(it => [it.value.poiId, this.etaOf(it)])));
  }

  private etaRequest(forms: UntypedFormGroup[]): TaskEtaRequest[] {
    return forms.map(it => {
      return {
        idx: it.value.idx,
        duration: it.value.duration,
        distance: it.value.distance,
        durationItself: it.value.durationItself != null ? it.value.durationItself * SECONDS_IN_MINUTE : null,
        durationRemaining: it.value.durationRemaining,
        distanceRemaining: it.value.distanceRemaining,
        timeFrom: it.value.timeFrom,
        timeTill: it.value.timeTill
      }
    });
  }

  public parkingBooking(form: UntypedFormGroup): void {
    if (form.value.parkingType != null) {
      let request = this.etaRequest(this.forms.filter(it => it.value.idx <= form.value.idx));
      this.managerService.getETA(this.data.vehicle.id, request)
        .pipe(takeUntil(this.subSubject))
        .subscribe({
          next: (eta) => this.openModal(form, eta),
          error: () => this.openModal(form, null)
        });
    }
  }

  private openModal(form: UntypedFormGroup, eta: string): void {
    let data = form.value;
    let modalReference = this.getModalRef(data.parkingType);
    modalReference.componentInstance.parkingId = data.parkingId;
    modalReference.componentInstance.bookingId = data.bookingId;
    modalReference.componentInstance.taskId = data.id;
    modalReference.componentInstance.etaToParking = eta;
    modalReference.componentInstance.vehicleId = this.vehicle;
    modalReference.componentInstance.modalReference = modalReference;
    modalReference.componentInstance.newBooking.pipe(takeUntil(this.subSubject)).subscribe(
      (newBooking: NewBookingInfo) => this.updateBookingInfo(form, newBooking)
    );
  }

  private getModalRef(parkingType: string): any {
    if (parkingType != null) {
      switch (parkingType) {
        case 'BOSCH':
          return this.modalService.open(BoschParkingFormComponent, {windowClass: 'form-modal'});
        case 'TRAVIS':
          return this.modalService.open(TravisParkingFormComponent, {windowClass: 'form-modal'});
        default:
          return null;
      }
    }
    return null;
  }

  private updateBookingInfo(form: UntypedFormGroup, newBooking: NewBookingInfo): void {
    if (newBooking != null) {
      this.managerService.translationFile(newBooking.driverLang)
        .pipe(takeUntil(this.subSubject))
        .subscribe(
          (translations) => {
            form.patchValue({
              bookingId: newBooking.bookingId,
              comments: appendReservationLink(newBooking, translations, form.value.comments)
            });
            this.patchOption(form, newBooking.startDate, LOAD_TIME_ADDITIONAL_ID);
            this.cd.detectChanges();
          });
    } else {
      form.patchValue({bookingId: null});
      this.patchOption(form, null, LOAD_TIME_ADDITIONAL_ID);
      this.cd.detectChanges();
    }
  }

  protected suggestPlan(init: boolean) {
    if (!this.suggestionsActive) {
      const queue = this.forms.length > 0 ? this.forms.map(it => it.value) : null;
      this.managerService.suggestPlan(this.vehicle, queue, init, this.replanSuggestionId).subscribe({
        next: (data: FuellingPlanResponse) => {
          let replannedTasks = data.tasks;
          this.tasksBeforeSuggestion = this.forms;
          const plannedTasksUuids = this.tasksBeforeSuggestion.map(it => it.controls.uuid.value);
          const suggestedTasksUuids = replannedTasks.map(it => it.uuid);
          this.suggestionTaskUuids = suggestedTasksUuids.filter(
            uuid => !plannedTasksUuids.includes(uuid)
          );
          if (this.suggestionTaskUuids.length === 0 || (replannedTasks.length === 0)) {
            this.tasksBeforeSuggestion = [];
            this.suggestionTaskUuids = [];
            this.notification.nothingFoundAlert();
            this.formStateService.triggerSuggestedStation(null);
            this.formStateService.triggerReplacedStations(null);
          } else {
            let sorted = replannedTasks.sort((a, b) => a.idx > b.idx ? 1 : -1);
            sorted.forEach(it => it.idx = sorted.indexOf(it));
            this.forms = sorted.map(it => this.toForm(it));
            this.formStateService.postForms(this.forms);
            this.activeForm = this.forms[0];
            this.cd.detectChanges();
            this.suggestionsActive = true;
            this.determineFuelWarning();
            this.formStateService.triggerReloadFuel(this.forms);
            this.formStateService.triggerSuggestedStation(data.suggestedStation);
            this.formStateService.triggerReplacedStations(data.replacedStations);
          }
        },
        error: () => this.notification.loadingError()
      });
    } else {
      const tasksBeforeSuggestionUuids = this.tasksBeforeSuggestion.map(it => it.controls.uuid.value);
      const addedNewTasksDuringSuggestion = this.forms.filter(task => {
        let uuid = task.controls.uuid.value;
        return !tasksBeforeSuggestionUuids.includes(uuid) && !this.suggestionTaskUuids.includes(uuid);
      }).length > 0;
      if (addedNewTasksDuringSuggestion) {
        this.forms = this.forms.filter(it => !this.suggestionTaskUuids.includes(it.controls.uuid.value));
        this.forms.forEach(it => it.patchValue({idx: this.forms.indexOf(it)}));
        this.cd.detectChanges();
        let firstForm = this.forms[0];
        this.reassignOrigins(firstForm.controls.origin.value, firstForm.controls.originPosition.value, true);
        this.formStateService.reloadAll({
          shouldRecenter: true,
          formIdx: null,
          forms: this.forms
        });
        this.formStateService.triggerReloadFuel(this.forms);
      } else {
        this.forms = this.tasksBeforeSuggestion;
        this.cd.detectChanges();
        this.formStateService.postForms(this.forms);
        this.activeForm = this.forms[0];
        this.formStateService.triggerReloadFuel(this.forms);
      }
      this.suggestionsActive = false;
      this.tasksBeforeSuggestion = [];
      this.suggestionTaskUuids = [];
      this.formStateService.triggerSuggestedStation(null);
      this.formStateService.triggerReplacedStations(null);
    }
  }

  public calculateRemainingDistance(): number {
    let index = this.activeForm.value.idx;
    let remainingDistance = 0;
    this.forms.forEach(it => {
      if (it.value.idx <= index) {
       remainingDistance = remainingDistance + it.value.distance;
      }
    });
    return this.traveledDistance > 0 ? remainingDistance - this.traveledDistance : remainingDistance;
  }

  /*------------------------------------------------Clearing----------------------------------------------------------*/

  public ngOnDestroy(): void {
    this.unsubscribeEverything();
    SubscriptionUtils.safeUnsubscribeSubject(this.subSubject);
    document.removeEventListener('click', this.clickListener);
    this.clickListener();
    this.tasksBeforeSuggestion = [];
    this.suggestionTaskUuids = [];
    this.formStateService.triggerSuggestedStation(null);
    this.formStateService.triggerReplacedStations(null);
  }

  private unsubscribeEverything() {
    SubscriptionUtils.safeUnsubscribe(this.idSubs);
    SubscriptionUtils.safeUnsubscribe(this.vehicleSubs);
    SubscriptionUtils.safeUnsubscribe(this.searchSubs);
    SubscriptionUtils.safeUnsubscribe(this.routeChangesSubs);
    SubscriptionUtils.safeUnsubscribe(this.taskSubs);
    SubscriptionUtils.safeUnsubscribe(this.oldTaskSubs);
    SubscriptionUtils.safeUnsubscribe(this.formValueChangeSubs);
    SubscriptionUtils.safeUnsubscribe(this.routeCostSubs);
    SubscriptionUtils.safeUnsubscribe(this.multiTemplateSubs);
    SubscriptionUtils.safeUnsubscribe(this.markedPaidRoadsTollsSubs);
    SubscriptionUtils.safeUnsubscribe(this.driverLangSub);
  }

  public shouldShowMarkedRoadsTolls(tolls: number) {
    if (tolls != null) {
      let tasksConfigs = AuthStorage.getTasksConfigs();
      if (tasksConfigs != null) {
        return tasksConfigs.markedPaidRoadsTolls;
      }
    }
    return false;
  }

  private handleLKWOrder() {
    if (this.lkwOrder.items != null) {
      this.lkwOrder.items.forEach(item => {
        let data = {
          lat: item.lat,
          lng: item.lng,
          lastPosition: true,
          poiType: null,
          poiId: null,
          isCRTCardless: false,
          lkwItem: item,
          lkwOrderNumber: this.lkwOrder.orderNumber,
          position: this.lkwOrder.position
        }
        this.addTaskFromMarker(data)
      })
    }
  }

  private handleOptimalFuelling() {
    if (!this.optimalFuelling || !this.optimalFuelling.length) {
      return;
    }

    window.history.replaceState(null, '');

    setTimeout(() => {
      this.optimalFuelling.forEach(fueling => {
        const data: PoiInsertTask = {
          lat: fueling.latitude,
          lng: fueling.longitude,
          name: fueling.name,
          type: 'FUELLING',
          poiId: fueling.poiId,
          externalId: fueling.externalId,
          comment: fueling.comment
        };

        if (fueling.replacedTask != null) {
          const form = this.forms.find(it => it.value.id === fueling.replacedTask);
          if (form) {
            this.delete(form);
          }
        }

        this.addTaskFromMarker(data);
      });

      this.optimalFuelling = [];
    }, 1000);
  }

  public copyToClipboard(): void {
    this.clipboardService.copyFromContent(this.activeForm.value.destination);
    this.notification.copiedSuccessfully();
  }

  private calculateCO2Emission(routeDistance: number): number {
    let emissionRatio = 2.66;
    return this.fuelUsageFor100km != null && this.fuelUsageFor100km > 0 && routeDistance > 0
      ? round(routeDistance / 100000 * this.fuelUsageFor100km * emissionRatio)
      : 0;
  }

  public quickPoiAdd(): void {
    let poiForm: POIForm = {
      poiGroupId: null,
      name: '',
      address: this.activeForm.value.destinationPosition?.address ?? null,
      coordinates: this.activeForm.value.destinationPosition.lat.toFixed(6)
        + ', '
        + this.activeForm.value.destinationPosition.lng.toFixed(6),
      placeId: '',
      comment: '',
      favorite: false
    };
    let popup = this.modalService.open(PoiModalComponent);
    popup.componentInstance.poiFormEntry = poiForm;
    popup.result.then((poiName) => {
      if (poiName != null) {
        this.activeForm.patchValue({
          destination: poiName
        });
      }
    })
  }

  public activateMap() {
    this.mapActive = true;
    this.taskFormActive = false;
    this.tabsActive = false;
    this.routeParamsActive = false;
    this.fuellingActive = false;
    this.parkingsActive = false;
    this.templatesActive = false;
    this.formsActive = false;
  }

  public activateTaskForm() {
    this.mapActive = false;
    this.taskFormActive = true;
    this.tabsActive = false;
    this.routeParamsActive = false;
    this.fuellingActive = false;
    this.parkingsActive = false;
    this.templatesActive = false;
    this.formsActive = false;
  }

  public activateTabs() {
    this.mapActive = false;
    this.taskFormActive = false;
    this.tabsActive = true;
    this.routeParamsActive = false;
    this.fuellingActive = false;
    this.parkingsActive = false;
    this.templatesActive = false;
    this.formsActive = false;
  }

}
